'use client';

export const SvgSprite = (): React.JSX.Element => {
  return (
    <svg display="none"
      height="0"
      width="0"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <symbol fill="none"
          id="search"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <g clipPath="url(#clip0_642_925)">
            <path clipRule="evenodd"
              d="M11 3
            C6.58172 3 3 6.58172 3 11
            C3 15.4183 6.58172 19 11 19
            C12.8487 19 14.551 18.3729 15.9056 17.3199
            L19.2929 20.7071
            C19.6834 21.0976 20.3166 21.0976 20.7071 20.7071
            C21.0976 20.3166 21.0976 19.6834 20.7071 19.2929
            L17.3199 15.9056
            C18.3729 14.551 19 12.8487 19 11
            C19 6.58172 15.4183 3 11 3
            Z
            M5 11
            C5 7.68629 7.68629 5 11 5
            C14.3137 5 17 7.68629 17 11
            C17 14.3137 14.3137 17 11 17
            C7.68629 17 5 14.3137 5 11
            Z"
              fill="currentColor"
              fillRule="evenodd"
            />
          </g>
          <defs>
            <clipPath id="clip0_642_925">
              <rect fill="white"
                height="24"
                width="24"
              />
            </clipPath>
          </defs>

        </symbol>

        <symbol aria-labelledby="icon-title-cart"
          id="shoppingcart"
          viewBox="0 0 20 20"
        >
          <title id="icon-title-cart">Shopping Cart</title>
          <path clipRule="evenodd"
            d="M5.00011 0.000201409C5.52858 -0.0103154 5.97396 0.392259 6.01673 0.919101L6.19348 3.09193L19.0767 4.08295C19.3837 4.10657 19.6628 4.27032 19.8331
            4.52686C20.0034 4.78339 20.0461 5.1041 19.9487 5.39623L17.9487 11.3962C17.8126 11.8046 17.4304 12.08 17 12.08H6.89476L6.94809 13.08H17C18.6569 13.08
            20 14.4231 20 16.08C20 17.7369 18.6569 19.08 17 19.08C15.3431 19.08 14 17.7369 14 16.08C14 15.7294 14.0602 15.3928 14.1707 15.08H9.8293C9.93985
            15.3928 10 15.7294 10 16.08C10 17.7369 8.65686 19.08 7 19.08C5.34315 19.08 4 17.7369 4 16.08C4 15.198 4.38065 14.4048 4.98663 13.8559L4.84217
            11.1472L4.09939 2.01852L1.0199 2.07981C0.467725 2.09079 0.0111906 1.65208 0.000201995 1.0999C-0.0107865 0.547724 0.427932 0.0911899 0.980107
            0.0802013L5.00011 0.000201409ZM6.76196 10.08L6.35769 5.11047L17.6463 5.97883L16.2792 10.08H6.76196ZM6 16.08C6 15.5277 6.44772 15.08 7 15.08C7.55229
            15.08 8 15.5277 8 16.08C8 16.6323 7.55229 17.08 7 17.08C6.44772 17.08 6 16.6323 6 16.08ZM16 16.08C16 15.5277 16.4477 15.08 17 15.08C17.5523 15.08 18
            15.5277 18 16.08C18 16.6323 17.5523 17.08 17 17.08C16.4477 17.08 16 16.6323 16 16.08Z"
            fillRule="evenodd"
          />
        </symbol>
        <symbol aria-hidden="true"
          id="externalsite"
          viewBox="0 0 12 12"
        >
          <path clipRule="evenodd"
            d="M6.6499 1.00002C6.6499 0.668654 6.91853 0.400024 7.2499 0.400024H10.9999C11.3313 0.400024 11.5999 0.668654 11.5999 1.00002V4.75002C11.5999 5.0814
            11.3313 5.35002 10.9999 5.35002C10.6685 5.35002 10.3999 5.0814 10.3999 4.75002V2.44856L4.28855 8.55992C4.05423 8.79423 3.67433 8.79423 3.44002
            8.55992C3.2057 8.3256 3.2057 7.9457 3.44002 7.71139L9.55138 1.60002H7.2499C6.91853 1.60002 6.6499 1.3314 6.6499 1.00002ZM2.2499 2.22502C2.07751
            2.22502 1.91218 2.29351 1.79028 2.4154C1.66838 2.5373 1.5999 2.70263 1.5999 2.87502V9.75002C1.5999 9.92242 1.66838 10.0877 1.79028 10.2096C1.91218
            10.3315 2.07751 10.4 2.2499 10.4H9.1249C9.29729 10.4 9.46262 10.3315 9.58452 10.2096C9.70642 10.0877 9.7749 9.92242 9.7749 9.75002V7.87502C9.7749
            7.54365 10.0435 7.27502 10.3749 7.27502C10.7063 7.27502 10.9749 7.54365 10.9749 7.87502V9.75002C10.9749 10.2407 10.78 10.7112 10.4331
            11.0582C10.0861 11.4051 9.61555 11.6 9.1249 11.6H2.2499C1.75925 11.6 1.2887 11.4051 0.941755 11.0582C0.594812 10.7112 0.399902 10.2407 0.399902
            9.75002V2.87502C0.399902 2.38437 0.594812 1.91382 0.941755 1.56688C1.2887 1.21993 1.75925 1.02502 2.2499 1.02502H4.1249C4.45627 1.02502 4.7249
            1.29365 4.7249 1.62502C4.7249 1.9564 4.45627 2.22502 4.1249 2.22502H2.2499Z"
            fillRule="evenodd"
          />
        </symbol>
        <symbol aria-labelledby="icon-title-location"
          id="location"
          viewBox="0 0 22 22"
        >
          <title id="icon-title-location">Location</title>
          <path d="M11,1.29c-4.42,0-7.88,3.46-7.88,7.88c0,4.6,6.27,11.08,7.88,11.08c1.84,0,7.88-6.73,7.88-11.08
            C18.88,4.75,15.42,1.29,11,1.29z M11,18.17c-1.3-0.85-5.87-5.57-5.87-9c0-3.29,2.58-5.88,5.88-5.88c3.29,0,5.88,2.58,5.88,5.88
            C16.88,12.59,12.3,17.32,11,18.17z"
          />
          <path d="M11,5.88c-1.81,0-3.29,1.48-3.29,3.29s1.48,3.29,3.29,3.29c1.82,0,3.29-1.48,3.29-3.29S12.82,5.88,11,5.88z M11,10.46
            c-0.71,0-1.29-0.58-1.29-1.29S10.29,7.88,11,7.88c0.71,0,1.29,0.58,1.29,1.29S11.71,10.46,11,10.46z"
          />
        </symbol>

        <symbol aria-labelledby="icon-platinum-star"
          fill="none"
          id="platinumStar"
          viewBox="0 0 68 68"
        >
          <title id="icon-platinum-star">Platinum Star</title>
          <circle cx="34"
            cy="34"
            fill="white"
            r="34"
          />
          <path d="M33.8587 14.0684
            L38.9575 29.3347
            H55.1038
            L42.0735 38.6641
            L46.889 53.9304
            L33.8587 44.601
            L20.8284 53.9304
            L25.9272 38.6641
            L12.8969 29.3347
            H29.0432
            L33.8587 14.0684
            Z"
          fill="black"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-profile"
          id="profile"
          viewBox="0 0 18 18"
        >
          <title id="icon-title-profile">Profile &amp; Payment</title>
          <path clipRule="evenodd"
            d={
              `M12.3994 8.66668C13.3839 7.75351 14 6.44871 14 5C14 2.23858 11.7614 0 9 0C6.23858 0 4 2.23858 4 5C4 6.44871 ` +
              `4.61612 7.75351 5.60063 8.66668C4.50165 9.11498 3.49159 9.78049 2.63604 10.636C0.948212 12.3239 0 14.6131 0 17C0 17.5523 ` +
              `0.447715 18 1 18C1.55228 18 2 17.5523 2 17C2 15.1435 2.7375 13.363 4.05025 12.0503C5.36301 10.7375 7.14348 10 9 10C10.8565 10 ` +
              `12.637 10.7375 13.9497 12.0503C15.2625 13.363 16 15.1435 16 17C16 17.5523 16.4477 18 17 18C17.5523 18 18 17.5523 18 17C18 14.6131 ` +
              `17.0518 12.3239 15.364 10.636C14.5084 9.78049 13.4984 9.11498 12.3994 8.66668ZM6 5C6 3.34315 7.34315 2 9 2C10.6569 2 12 3.34315 ` +
              `12 5C12 6.65685 10.6569 8 9 8C7.34315 8 6 6.65685 6 5Z`
            }
            fillRule="evenodd"
          />
        </symbol>

        <symbol height="21"
          id="qlmcpstar"
          viewBox="0 0 19 21"
          width="19"
        >
          <circle cx="9"
            cy="9"
            fill="#DD0000"
            r="9"
          />
          <path d="M8.96276 3.8183
            L10.3465 7.78735
            H14.7285
            L11.1922 10.2129
            L12.4991 14.1819
            L8.96276 11.7564
            L5.42646 14.1819
            L6.81023 10.2129
            L3.27393 7.78735
            H7.65586
            L8.96276 3.8183
            Z"
          fill="#FAFAFA"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-scan"
          id="scan"
          viewBox="0 0 21 21"
        >
          <title id="icon-title-scan">Scan Member ID</title>
          <path clipRule="evenodd"
            d="M3.5 2.33333
            C2.85567 2.33333 2.33333 2.85567 2.33333 3.5
            V7
            C2.33333 7.64433 1.811 8.16667 1.16667 8.16667
            C0.522334 8.16667 0 7.64433 0 7
            V3.5
            C0 1.567 1.567 0 3.5 0
            H7
            C7.64433 0 8.16667 0.522334 8.16667 1.16667
            C8.16667 1.811 7.64433 2.33333 7 2.33333
            H3.5
            Z
            M1.16667 12.8333
            C1.811 12.8333 2.33333 13.3557 2.33333 14
            V17.5
            C2.33333 18.1443 2.85567 18.6667 3.5 18.6667
            H7
            C7.64433 18.6667 8.16667 19.189 8.16667 19.8333
            C8.16667 20.4777 7.64433 21 7 21
            H3.5
            C1.567 21 0 19.433 0 17.5
            V14
            C0 13.3557 0.522334 12.8333 1.16667 12.8333
            Z"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M17.5 18.6667
            C18.1443 18.6667 18.6667 18.1443 18.6667 17.5
            L18.6667 14
            C18.6667 13.3557 19.189 12.8333 19.8333 12.8333
            C20.4777 12.8333 21 13.3557 21 14
            L21 17.5
            C21 19.433 19.433 21 17.5 21
            L14 21
            C13.3557 21 12.8333 20.4777 12.8333 19.8333
            C12.8333 19.189 13.3557 18.6667 14 18.6667
            L17.5 18.6667
            Z
            M19.8333 8.16667
            C19.189 8.16667 18.6667 7.64433 18.6667 7
            L18.6667 3.5
            C18.6667 2.85567 18.1443 2.33334 17.5 2.33334
            L14 2.33334
            C13.3557 2.33334 12.8333 1.811 12.8333 1.16667
            C12.8333 0.522336 13.3557 3.14641e-06 14 3.20274e-06
            L17.5 3.50872e-06
            C19.433 3.67771e-06 21 1.56701 21 3.5
            L21 7
            C21 7.64433 20.4777 8.16667 19.8333 8.16667
            Z"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M4.66669 8.16669
            C4.66669 6.23369 6.23369 4.66669 8.16669 4.66669
            H12.8334
            C14.7663 4.66669 16.3334 6.23369 16.3334 8.16669
            V12.8334
            C16.3334 14.7663 14.7663 16.3334 12.8334 16.3334
            H8.16669
            C6.23369 16.3334 4.66669 14.7663 4.66669 12.8334
            V8.16669
            Z
            M8.16669 7.00002
            C7.52235 7.00002 7.00002 7.52235 7.00002 8.16669
            V12.8334
            C7.00002 13.4777 7.52235 14 8.16669 14
            H12.8334
            C13.4777 14 14 13.4777 14 12.8334
            V8.16669
            C14 7.52235 13.4777 7.00002 12.8334 7.00002
            H8.16669
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-tickets"
          id="tickets"
          viewBox="0 0 15 18"
        >
          <title id="icon-title-tickets">Tickets</title>
          <path clipRule="evenodd"
            d="M10.8 0
            H12.6
            C13.0774 0 13.5352 0.189641 13.8728 0.527207
            C14.2103 0.864773 14.4 1.32261 14.4 1.8
            V16.2
            C14.4 16.6774 14.2103 17.1352 13.8728 17.4728
            C13.5352 17.8103 13.0774 18 12.6 18
            H10.7873
            L10.7747 17.9996
            C10.4534 17.9906 10.1403 17.8957 9.86811 17.7247
            C9.59589 17.5538 9.37441 17.3131 9.22667 17.0276
            L9.22146 17.0175
            L9.2165 17.0073
            C9.03346 16.6307 8.74813 16.3131 8.39313 16.0909
            C8.03813 15.8687 7.62778 15.7509 7.20899 15.7509
            C6.79019 15.7509 6.37985 15.8687 6.02485 16.0909
            C5.66985 16.3131 5.38452 16.6307 5.20147 17.0073
            L5.19644 17.0177
            L5.19113 17.0279
            C5.0405 17.3187 4.8134 17.5629 4.53428 17.7342
            C4.25516 17.9055 3.93461 17.9973 3.60714 17.9999
            L3.59999 18
            L1.8 18
            C1.32261 18 0.864773 17.8103 0.527207 17.4728
            C0.189642 17.1352 0 16.6774 0 16.2
            V1.8
            C0 1.32261 0.189642 0.864772 0.527207 0.527207
            C0.864772 0.189642 1.32261 0 1.8 0
            H3.61265
            L3.62531 0.000355982
            C3.94662 0.00939603 4.25964 0.104312 4.53186 0.275242
            C4.80408 0.446171 5.02557 0.686878 5.1733 0.972354
            L5.17852 0.982429
            L5.18347 0.992631
            C5.36652 1.36931 5.65185 1.68689 6.00685 1.90907
            C6.36184 2.13125 6.77219 2.24908 7.19099 2.24908
            C7.60978 2.24908 8.02013 2.13125 8.37513 1.90907
            C8.73013 1.68689 9.01546 1.36931 9.1985 0.992631
            L9.20354 0.982263
            L9.20884 0.972027
            C9.35947 0.681247 9.58658 0.437068 9.8657 0.26579
            C10.1448 0.0945126 10.4654 0.00262695 10.7928 2.83241e-05
            L10.8 0
            Z
            M3.57461 1.8
            H1.8
            L1.8 16.2
            H3.59261
            C3.92362 15.5286 4.4351 14.9624 5.06989 14.5651
            C5.71118 14.1637 6.45245 13.9509 7.20899 13.9509
            C7.96552 13.9509 8.7068 14.1637 9.34809 14.5651
            C9.98288 14.9624 10.4944 15.5286 10.8254 16.2
            H12.6
            V1.8
            H10.8074
            C10.4764 2.47141 9.96488 3.03756 9.33008 3.43487
            C8.6888 3.83623 7.94752 4.04908 7.19099 4.04908
            C6.43445 4.04908 5.69318 3.83623 5.05189 3.43487
            C4.4171 3.03756 3.90562 2.47141 3.57461 1.8
            Z"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M4.49999 7.19999
            C4.49999 6.70293 4.90294 6.29999 5.39999 6.29999
            H8.99999
            C9.49704 6.29999 9.89998 6.70293 9.89998 7.19999
            C9.89998 7.69704 9.49704 8.09999 8.99999 8.09999
            H5.39999
            C4.90294 8.09999 4.49999 7.69704 4.49999 7.19999
            Z"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M4.49999 10.8
            C4.49999 10.3029 4.90294 9.89998 5.39999 9.89998
            H8.99999
            C9.49704 9.89998 9.89998 10.3029 9.89998 10.8
            C9.89998 11.297 9.49704 11.7 8.99999 11.7
            H5.39999
            C4.90294 11.7 4.49999 11.297 4.49999 10.8
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol fill="none"
          id="email"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path clipRule="evenodd"
            d="M3.94006 3.82996
            C2.90176 3.82996 2.06006 4.67166 2.06006 5.70996
            V18.01
            C2.06006 19.0483 2.90176 19.89 3.94006 19.89
            H20.0601
            C21.0984 19.89 21.9401 19.0483 21.9401 18.01
            V5.70996
            C21.9401 4.67166 21.0984 3.82996 20.0601 3.82996
            H3.94006
            Z
            M18.4584 5.70996
            L5.54174 5.70996
            L11.3861 10.2556
            C11.7472 10.5364 12.2529 10.5364 12.614 10.2556
            L18.4584 5.70996
            Z
            M3.94006 6.99792
            V18.01
            H20.0601
            V6.99793
            L13.8419 11.8343
            C12.7586 12.6769 11.2416 12.6769 10.1582 11.8343
            L3.94006 6.99792
            Z"
            fill="currentColor"
            fillRule="evenodd"
          />

        </symbol>

        <symbol aria-labelledby="icon-title-giftcard"
          id="giftcard"
          viewBox="0 0 16 13"
        >
          <title id="icon-title-giftcard">Gift Card</title>
          <path clipRule="evenodd"
            d="M1.51308 0
            C0.677428 0 0 0.677428 0 1.51308
            V11.4125
            C0 12.2481 0.677428 12.9256 1.51308 12.9256
            H14.4869
            C15.3226 12.9256 16 12.2481 16 11.4125
            V1.51308
            C16 0.677428 15.3226 0 14.4869 0
            H1.51308
            Z
            M1.51308 1.51308
            H14.4869
            V3.35614
            H1.51308
            V1.51308
            Z
            M1.51308 4.96579
            V11.4125
            H14.4869
            V4.96579
            H1.51308
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-signin"
          id="signin"
          viewBox="0 0 18 18"
        >
          <title id="icon-title-signin">Sign In</title>
          <path clipRule="evenodd"
            d="M15.092 0
            H7.99202
            L7.98805 8.79764e-06
            C7.2144 0.00342448 6.47341 0.31227 5.92635 0.859328
            C5.3793 1.40639 5.07044 2.14737 5.06702 2.92102
            V3.6
            C5.06702 4.09705 5.46997 4.5 5.96702 4.5
            C6.46408 4.5 6.86702 4.09705 6.86702 3.6
            V2.92727
            C6.86879 2.62887 6.98811 2.34316 7.19914 2.13212
            C7.41018 1.92108 7.69589 1.80176 7.99429 1.8
            H15.0795
            C15.3764 1.80351 15.6601 1.92335 15.8697 2.13385
            C16.0796 2.34475 16.1983 2.62972 16.2 2.92727
            V15.0727
            C16.1983 15.3703 16.0796 15.6552 15.8697 15.8661
            C15.6601 16.0766 15.3763 16.1965 15.0794 16.2
            H7.99433
            C7.69591 16.1982 7.41019 16.0789 7.19914 15.8679
            C6.98811 15.6568 6.86879 15.3711 6.86702 15.0727
            V14.4
            C6.86702 13.9029 6.46408 13.5 5.96702 13.5
            C5.46997 13.5 5.06702 13.9029 5.06702 14.4
            V15.075
            L5.06703 15.079
            C5.07045 15.8526 5.3793 16.5936 5.92635 17.1407
            C6.47341 17.6877 7.2144 17.9966 7.98805 18
            L7.99202 18
            L15.084 18
            L15.092 18
            C15.8634 17.9931 16.601 17.6828 17.1453 17.1361
            C17.6896 16.5894 17.9966 15.8504 18 15.0789
            L18 2.925
            L18 2.92105
            C17.9966 2.14963 17.6896 1.41059 17.1453 0.863894
            C16.601 0.317202 15.8634 0.0068193 15.092 0
            Z
            M8.36367 11.0636
            L9.52725 9.90001
            L0.899999 9.90001
            C0.402943 9.90001 -4.34538e-08 9.49707 0 9.00001
            C4.34538e-08 8.50296 0.402943 8.10001 0.899999 8.10001
            L9.52727 8.10001
            L8.36367 6.93641
            C8.0122 6.58494 8.0122 6.01509 8.36367 5.66362
            C8.71514 5.31215 9.28499 5.31215 9.63646 5.66362
            L12.3327 8.35983
            C12.3339 8.36108 12.3352 8.36234 12.3365 8.3636
            C12.4683 8.4954 12.5506 8.65791 12.5836 8.8281
            C12.6145 8.98787 12.6019 9.15442 12.5457 9.30867
            C12.5021 9.42826 12.4324 9.54047 12.3365 9.63641
            C12.3352 9.63764 12.334 9.63887 12.3328 9.64009
            L9.63646 12.3364
            C9.28499 12.6879 8.71514 12.6879 8.36367 12.3364
            C8.0122 11.9849 8.0122 11.4151 8.36367 11.0636
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-signout"
          id="signout"
          viewBox="0 0 18 18"
        >
          <title id="icon-title-signout">Sign Out</title>
          <path clipRule="evenodd"
            d="M15.0918 0
            H7.99189
            L7.98792 8.79763e-06
            C7.21427 0.00342448 6.47328 0.31227 5.92622 0.859327
            C5.37916 1.40638 5.07031 2.14737 5.06689 2.92102
            V3.59999
            C5.06689 4.09705 5.46984 4.49999 5.96689 4.49999
            C6.46395 4.49999 6.86689 4.09705 6.86689 3.59999
            V2.92726
            C6.86866 2.62886 6.98797 2.34316 7.19901 2.13212
            C7.41005 1.92108 7.69576 1.80176 7.99416 1.8
            H15.0793
            C15.3762 1.80351 15.66 1.92335 15.8695 2.13385
            C16.0795 2.34475 16.1981 2.62972 16.1999 2.92727
            V15.0727
            C16.1981 15.3702 16.0795 15.6552 15.8695 15.8661
            C15.66 16.0766 15.3762 16.1965 15.0793 16.2
            H7.9942
            C7.69578 16.1982 7.41006 16.0789 7.19901 15.8678
            C6.98797 15.6568 6.86866 15.3711 6.86689 15.0727
            V14.4
            C6.86689 13.9029 6.46395 13.5 5.96689 13.5
            C5.46984 13.5 5.06689 13.9029 5.06689 14.4
            V15.075
            L5.0669 15.0789
            C5.07032 15.8526 5.37916 16.5936 5.92622 17.1406
            C6.47328 17.6877 7.21427 17.9965 7.98792 18
            L7.99189 18
            L15.0839 18
            L15.0918 17.9999
            C15.8632 17.9931 16.6009 17.6828 17.1452 17.1361
            C17.6894 16.5894 17.9965 15.8503 17.9999 15.0789
            L17.9999 2.92499
            L17.9999 2.92105
            C17.9965 2.14963 17.6894 1.41059 17.1452 0.863893
            C16.6009 0.317201 15.8632 0.00681929 15.0918 0
            Z
            M4.23639 6.93643
            L3.07286 8.09996
            H11.6998
            C12.1969 8.09996 12.5998 8.5029 12.5998 8.99996
            C12.5998 9.49701 12.1969 9.89996 11.6998 9.89996
            H3.07279
            L4.23639 11.0636
            C4.58786 11.415 4.58786 11.9849 4.23639 12.3363
            C3.88492 12.6878 3.31507 12.6878 2.9636 12.3363
            L0.270502 9.64325
            C0.268193 9.64099 0.265894 9.63872 0.263603 9.63643
            C0.0878586 9.46068 -9.21639e-06 9.23034 7.25063e-10 9
            C-9.21639e-06 8.76965 0.0878586 8.53931 0.263603 8.36356
            C0.265894 8.36127 0.268193 8.359 0.270502 8.35674
            L2.9636 5.66364
            C3.31507 5.31217 3.88492 5.31217 4.23639 5.66364
            C4.58786 6.01511 4.58786 6.58496 4.23639 6.93643
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-cart"
          id="cart"
          viewBox="0 0 20 20"
        >
          <title id="icon-title-cart">Shopping Cart</title>
          <path clipRule="evenodd"
            d="M5.00011 0.000201409
            C5.52858 -0.0103154 5.97396 0.392259 6.01673 0.919101
            L6.19348 3.09193
            L19.0767 4.08295
            C19.3837 4.10657 19.6628 4.27032 19.8331 4.52686
            C20.0034 4.78339 20.0461 5.1041 19.9487 5.39623
            L17.9487 11.3962
            C17.8126 11.8046 17.4304 12.08 17 12.08
            H6.89476
            L6.94809 13.08
            H17
            C18.6569 13.08 20 14.4231 20 16.08
            C20 17.7369 18.6569 19.08 17 19.08
            C15.3431 19.08 14 17.7369 14 16.08
            C14 15.7294 14.0602 15.3928 14.1707 15.08
            H9.8293
            C9.93985 15.3928 10 15.7294 10 16.08
            C10 17.7369 8.65686 19.08 7 19.08
            C5.34315 19.08 4 17.7369 4 16.08
            C4 15.198 4.38065 14.4048 4.98663 13.8559
            L4.84217 11.1472
            L4.09939 2.01852
            L1.0199 2.07981
            C0.467725 2.09079 0.0111906 1.65208 0.000201995 1.0999
            C-0.0107865 0.547724 0.427932 0.0911899 0.980107 0.0802013
            L5.00011 0.000201409
            Z
            M6.76196 10.08
            L6.35769 5.11047
            L17.6463 5.97883
            L16.2792 10.08
            H6.76196
            Z
            M6 16.08
            C6 15.5277 6.44772 15.08 7 15.08
            C7.55229 15.08 8 15.5277 8 16.08
            C8 16.6323 7.55229 17.08 7 17.08
            C6.44772 17.08 6 16.6323 6 16.08
            Z
            M16 16.08
            C16 15.5277 16.4477 15.08 17 15.08
            C17.5523 15.08 18 15.5277 18 16.08
            C18 16.6323 17.5523 17.08 17 17.08
            C16.4477 17.08 16 16.6323 16 16.08
            Z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-cart"
          id="shoppingcart"
          viewBox="0 0 20 20"
        >
          <title id="icon-title-cart">Shopping Cart</title>
          <path clipRule="evenodd"
            d="M5.00011 0.000201409
            C5.52858 -0.0103154 5.97396 0.392259 6.01673 0.919101
            L6.19348 3.09193
            L19.0767 4.08295
            C19.3837 4.10657 19.6628 4.27032 19.8331 4.52686
            C20.0034 4.78339 20.0461 5.1041 19.9487 5.39623
            L17.9487 11.3962
            C17.8126 11.8046 17.4304 12.08 17 12.08
            H6.89476
            L6.94809 13.08
            H17
            C18.6569 13.08 20 14.4231 20 16.08
            C20 17.7369 18.6569 19.08 17 19.08
            C15.3431 19.08 14 17.7369 14 16.08
            C14 15.7294 14.0602 15.3928 14.1707 15.08
            H9.8293
            C9.93985 15.3928 10 15.7294 10 16.08
            C10 17.7369 8.65686 19.08 7 19.08
            C5.34315 19.08 4 17.7369 4 16.08
            C4 15.198 4.38065 14.4048 4.98663 13.8559
            L4.84217 11.1472
            L4.09939 2.01852
            L1.0199 2.07981
            C0.467725 2.09079 0.0111906 1.65208 0.000201995 1.0999
            C-0.0107865 0.547724 0.427932 0.0911899 0.980107 0.0802013
            L5.00011 0.000201409
            Z
            M6.76196 10.08
            L6.35769 5.11047
            L17.6463 5.97883
            L16.2792 10.08
            H6.76196
            Z
            M6 16.08
            C6 15.5277 6.44772 15.08 7 15.08
            C7.55229 15.08 8 15.5277 8 16.08
            C8 16.6323 7.55229 17.08 7 17.08
            C6.44772 17.08 6 16.6323 6 16.08
            Z
            M16 16.08
            C16 15.5277 16.4477 15.08 17 15.08
            C17.5523 15.08 18 15.5277 18 16.08
            C18 16.6323 17.5523 17.08 17 17.08
            C16.4477 17.08 16 16.6323 16 16.08
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-edit"
          id="edit"
          viewBox="0 0 16 17"
        >
          <title id="icon-title-edit">Edit</title>
          <path clipRule="evenodd"
            d="M11.5313 0.128854
            C11.7294 0.0438402 11.9426 0 12.1581 0
            C12.3736 0 12.5868 0.0438408 12.7849 0.128854
            C12.98 0.212628 13.1563 0.334659 13.3035 0.487703
            L15.5159 2.72383
            C15.6673 2.87027 15.788 3.04536 15.8711 3.23896
            C15.9562 3.43698 16 3.65023 16 3.86573
            C16 4.08124 15.9562 4.29448 15.8711 4.4925
            C15.7877 4.68691 15.6662 4.86267 15.514 5.00947
            L5.50832 15.0072
            C5.26889 15.255 4.95542 15.4183 4.61526 15.4724
            L1.83016 16.0055
            L1.81094 16.0082
            C1.56715 16.0427 1.31868 16.0199 1.08516 15.9419
            C0.851635 15.8638 0.639449 15.7326 0.465347 15.5585
            C0.291245 15.3844 0.159988 15.1722 0.0819378 14.9387
            C0.0038881 14.7052 -0.0188195 14.4567 0.0156078 14.2129
            L0.0182634 14.1941
            L0.553106 11.3843
            L0.553656 11.3813
            C0.613419 11.059 0.767658 10.7618 0.996791 10.5275
            L1.0024 10.5217
            L11.0141 0.486292
            C11.1609 0.333909 11.3368 0.212371 11.5313 0.128854
            Z
            M3.08515 14.1476
            L1.58994 14.4339
            L1.87481 12.9373
            L3.08515 14.1476
            Z
            M2.47734 11.2929
            L9.73012 4.02289
            L11.9909 6.28372
            L4.72666 13.5422
            L2.47734 11.2929
            Z
            M14.4039 3.87264
            L13.1148 5.16072
            L10.8522 2.89811
            L12.1514 1.59583
            L12.1581 1.58879
            L12.1637 1.59464
            L14.4023 3.85726
            L14.4112 3.86573
            L14.4039 3.87264
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-close"
          id="close"
          viewBox="0 0 22 22"
        >
          <title id="icon-title-close">Close</title>
          <path d="M12.41,11
            l6.63-6.63
            c0.39-0.39,0.39-1.02,0-1.41
            s-1.02-0.39-1.41,0
            L11,9.59
            L4.37,2.96
            c-0.39-0.39-1.02-0.39-1.41,0
            s-0.39,1.02,0,1.41
            L9.59,11
            l-6.63,6.63
            c-0.39,0.39-0.39,1.02,0,1.41
            c0.2,0.2,0.45,0.29,0.71,0.29
            s0.51-0.1,0.71-0.29
            L11,12.41
            l6.63,6.63
            c0.2,0.2,0.45,0.29,0.71,0.29
            s0.51-0.1,0.71-0.29
            c0.39-0.39,0.39-1.02,0-1.41
            L12.41,11
            z"
          fill="currentColor"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-calendar"
          id="calendar"
          viewBox="0 0 18 19"
        >
          <title id="icon-title-calendar">Calendar</title>
          <path d="M6.5 7.62H4V10.12H6.5V7.62Z" />
          <path d="M14.5 7.62H12V10.12H14.5V7.62Z" />
          <path d="M10.5 7.62H8V10.12H10.5V7.62Z" />
          <path d="M6.5 12.5H4V15H6.5V12.5Z" />
          <path d="M14.5 12.5H12V15H14.5V12.5Z" />
          <path d="M10.5 12.5H8V15H10.5V12.5Z" />
          <path clipRule="evenodd"
            d="M5 0
            C5.55228 0 6 0.447715 6 1
            V2
            H12
            V1
            C12 0.447715 12.4477 0 13 0
            C13.5523 0 14 0.447715 14 1
            V2
            H15
            C16.6569 2 18 3.34315 18 5
            V16
            C18 17.6569 16.6569 19 15 19
            H3
            C1.34315 19 0 17.6569 0 16
            V5
            C0 3.34315 1.34315 2 3 2
            H4
            V1
            C4 0.447715 4.44772 0 5 0
            Z
            M4 4
            H3
            C2.44772 4 2 4.44772 2 5
            V16
            C2 16.5523 2.44772 17 3 17
            H15
            C15.5523 17 16 16.5523 16 16
            V5
            C16 4.44772 15.5523 4 15 4
            H14
            V5
            C14 5.55228 13.5523 6 13 6
            C12.4477 6 12 5.55228 12 5
            V4
            H6
            V5
            C6 5.55228 5.55229 6 5 6
            C4.44772 6 4 5.55228 4 5
            V4
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol id="externalsite"
          viewBox="0 0 12 12"
        >
          <path clipRule="evenodd"
            d="M6.6499 1.00002
            C6.6499 0.668654 6.91853 0.400024 7.2499 0.400024
            H10.9999
            C11.3313 0.400024 11.5999 0.668654 11.5999 1.00002
            V4.75002
            C11.5999 5.0814 11.3313 5.35002 10.9999 5.35002
            C10.6685 5.35002 10.3999 5.0814 10.3999 4.75002
            V2.44856
            L4.28855 8.55992
            C4.05423 8.79423 3.67433 8.79423 3.44002 8.55992
            C3.2057 8.3256 3.2057 7.9457 3.44002 7.71139
            L9.55138 1.60002
            H7.2499
            C6.91853 1.60002 6.6499 1.3314 6.6499 1.00002
            Z
            M2.2499 2.22502
            C2.07751 2.22502 1.91218 2.29351 1.79028 2.4154
            C1.66838 2.5373 1.5999 2.70263 1.5999 2.87502
            V9.75002
            C1.5999 9.92242 1.66838 10.0877 1.79028 10.2096
            C1.91218 10.3315 2.07751 10.4 2.2499 10.4
            H9.1249
            C9.29729 10.4 9.46262 10.3315 9.58452 10.2096
            C9.70642 10.0877 9.7749 9.92242 9.7749 9.75002
            V7.87502
            C9.7749 7.54365 10.0435 7.27502 10.3749 7.27502
            C10.7063 7.27502 10.9749 7.54365 10.9749 7.87502
            V9.75002
            C10.9749 10.2407 10.78 10.7112 10.4331 11.0582
            C10.0861 11.4051 9.61555 11.6 9.1249 11.6
            H2.2499
            C1.75925 11.6 1.2887 11.4051 0.941755 11.0582
            C0.594812 10.7112 0.399902 10.2407 0.399902 9.75002
            V2.87502
            C0.399902 2.38437 0.594812 1.91382 0.941755 1.56688
            C1.2887 1.21993 1.75925 1.02502 2.2499 1.02502
            H4.1249
            C4.45627 1.02502 4.7249 1.29365 4.7249 1.62502
            C4.7249 1.9564 4.45627 2.22502 4.1249 2.22502
            H2.2499
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol fill="none"
          id="phone"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <g clipPath="url(#clip0_642_918)">
            <path clipRule="evenodd"
              d="M6.46199 2.11798
            C6.14508 2.10459 5.82866 2.15416 5.53102 2.26381
            C5.23338 2.37345 4.96044 2.54102 4.72795 2.7568
            L4.7225 2.76187
            L3.20127 4.28309
            C2.57557 4.87497 2.17909 5.66908 2.08241 6.52506
            L2.08141 6.53726
            C1.98694 7.68841 2.18681 8.84462 2.66216 9.89718
            C3.47275 11.9091 4.58913 13.7838 5.97188 15.455
            L5.97395 15.4574
            C7.85195 17.6904 10.1871 19.4945 12.8217 20.7481
            C14.0481 21.3859 15.3879 21.7768 16.7649 21.8984
            L16.7824 21.9
            H16.9919
            C17.5233 21.9211 18.0525 21.8195 18.5384 21.6029
            C19.0213 21.3877 19.4483 21.0646 19.7868 20.6587
            L20.5946 19.8411
            L20.5958 19.8399
            C20.7267 19.7062 20.8705 19.5859 21.0252 19.4806
            L21.048 19.4651
            L21.0685 19.4465
            C21.3075 19.2302 21.5014 18.9688 21.6392 18.6774
            C21.777 18.386 21.8559 18.0703 21.8715 17.7483
            C21.887 17.4264 21.8389 17.1045 21.7298 16.8012
            C21.6214 16.4998 21.455 16.2226 21.24 15.9853
            L21.1088 15.8322
            L21.092 15.8166
            C20.5633 15.3266 20.0674 14.8148 19.5716 14.303
            C19.3051 14.0279 19.0385 13.7528 18.7669 13.4811
            C18.5502 13.2526 18.2906 13.0689 18.003 12.9407
            C17.7135 12.8115 17.4014 12.7411 17.0845 12.7332
            C16.7677 12.7254 16.4524 12.7805 16.1569 12.8952
            C15.8615 13.0098 15.5916 13.1819 15.363 13.4015
            L15.349 13.4149
            L15.3289 13.4383
            L15.2053 13.5001
            L15.1607 13.5437
            C15.0469 13.6547 14.9297 13.7651 14.81 13.8776
            C14.571 14.1025 14.3225 14.3363 14.0741 14.6021
            L14.0644 14.6013
            C13.929 14.5568 13.8013 14.4913 13.6862 14.4071
            L13.6771 14.4004
            L13.6676 14.3943
            C12.3657 13.5506 11.206 12.5056 10.2315 11.2986
            L10.2232 11.2889
            C9.83845 10.8422 9.50722 10.3525 9.23599 9.82974
            L10.3053 8.76048
            C10.7679 8.34342 11.0505 7.76266 11.0928 7.14088
            C11.1354 6.51515 10.9314 5.8976 10.5244 5.42041
            L10.5106 5.40422
            L10.3091 5.2133
            L9.62007 4.42841
            L9.28007 4.04983
            L8.94619 3.7104
            L8.1293 2.89351
            C7.91715 2.66224 7.66168 2.47479 7.37734 2.34182
            C7.09001 2.20745 6.7789 2.13137 6.46199 2.11798
            Z
            M5.47225 4.94349
            L6.00915 4.40659
            C6.12503 4.29732 6.26811 4.22182 6.4229 4.1876
            C6.53098 4.21746 6.62896 4.27713 6.7053 4.36036
            L6.71113 4.36672
            L7.54518 5.20077
            L7.88304 5.54881
            L8.23841 5.89403
            L9.05548 6.72114
            L9.06016 6.72572
            C9.28659 6.94752 9.30757 7.05564 9.30757 7.08622
            C9.30757 7.10439 9.29952 7.19235 9.08338 7.3732
            L9.07443 7.38069
            L8.72589 7.70866
            L8.72136 7.71306
            C8.64466 7.78757 8.56663 7.86433 8.48751 7.94215
            C8.19378 8.23108 7.88512 8.53468 7.57474 8.79207
            L7.56673 8.79872
            L7.55907 8.80577
            C7.36311 8.98627 7.22836 9.22343 7.1736 9.48417
            C7.1191 9.74373 7.14657 10.0138 7.25217 10.257
            C7.61068 11.1145 8.09437 11.9141 8.68746 12.6296
            C9.76475 14.0306 11.0814 15.2298 12.5766 16.172
            C12.7878 16.3231 13.0163 16.4486 13.2572 16.5456
            C13.345 16.5883 13.4142 16.6113 13.4661 16.6286
            L13.4686 16.6294
            C13.5131 16.6443 13.5416 16.654 13.5779 16.6713
            C13.8413 16.8287 14.1493 16.8954 14.4546 16.8606
            C14.7617 16.8257 15.0485 16.69 15.2703 16.4752
            C15.6056 16.1875 15.9255 15.8502 16.2144 15.5455
            C16.3308 15.4227 16.4423 15.3052 16.5476 15.1984
            L16.7115 15.1165
            L16.7677 15.0432
            C16.8294 14.9625 16.9202 14.9091 17.0207 14.8944
            C17.1181 14.8801 17.2173 14.9032 17.2983 14.9589
            C17.3223 14.979 17.3435 15.0022 17.3614 15.0279
            L17.3809 15.056
            L19.7518 17.468
            L19.7973 17.4947
            C19.8279 17.5128 19.8496 17.5387 19.8467 17.6036
            C19.8433 17.6801 19.7991 17.8152 19.6472 17.9671
            L19.6443 17.9701
            C19.5134 18.1037 19.3696 18.2241 19.215 18.3293
            L19.1839 18.3505
            L19.1572 18.3771
            C18.8448 18.6896 18.5361 19.0181 18.2357 19.3999
            C18.0583 19.5891 17.8375 19.7324 17.5922 19.8174
            C17.3423 19.9039 17.0749 19.927 16.8138 19.8849
            L16.8004 19.8831
            C15.6905 19.7425 14.612 19.4177 13.609 18.9222
            C11.2635 17.735 9.17276 16.1004 7.45465 14.1107
            C6.22717 12.6485 5.23849 11.0015 4.52519 9.23066
            C4.25496 8.43614 4.12129 7.6016 4.12984 6.76246
            C4.16616 6.42291 4.31577 6.10543 4.55459 5.86127
            C4.8801 5.57562 5.18664 5.26904 5.47225 4.94349
            Z"
              fill="currentColor"
              fillRule="evenodd"
            />
          </g>
          <defs>
            <clipPath id="clip0_642_918">
              <rect fill="white"
                height="24"
                width="24"
              />
            </clipPath>
          </defs>

        </symbol>

        <symbol id="map"
          viewBox="0 0 14 14"
        >
          <path clipRule="evenodd"
            d="M14 12.1372
            V0
            L9.1 2.45
            L4.9 0.35
            L0 2.8
            V13.4653
            L4.84971 11.0404
            L8.99657 13.805
            L14 12.1372
            Z
            M1.4 11.2
            V3.66525
            L4.2 2.26525
            V9.8
            L1.4 11.2
            Z
            M5.6 9.858
            V2.26525
            L8.4 3.66525
            V11.7247
            L5.6 9.858
            Z
            M9.8 12.0614
            V3.66525
            L12.6 2.26525
            V11.1281
            L9.8 12.0614
            Z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </symbol>

        <symbol fill="none"
          id="map_active"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_6742_19196)">
            <path clipRule="evenodd"
              d="M14.25 22.7017
            L9.75 19.7017
            V4.25684
            L14.25 6.50684
            V22.7017
            Z
            M15.75 22.804
            L22 20.7206
            V3.38184
            L15.75 6.50684
            V22.804
            Z
            M2 7.38184
            L8.25 4.25684
            V19.4929
            L2 22.6179
            V7.38184
            Z"
              fill="currentColor"
              fillRule="evenodd"
            />
          </g>
          <defs>
            <clipPath id="clip0_6742_19196">
              <rect fill="white"
                height="24"
                width="24"
              />
            </clipPath>
          </defs>
        </symbol>

        <symbol aria-labelledby="icon-title-movieclub"
          id="movieclub"
          viewBox="0 0 38 30"
        >
          <title id="icon-title-movieclub">Movie Club</title>
          <path d="M14.6298 29.1073
            V5.95466
            L9.39133 21.1545
            H7.6542
            L2.46997 6.44323
            V29.1073
            H0
            V0.33615
            H2.38855
            L8.44134 17.2731
            L14.5484 0.33615
            H16.937
            V29.1073
            H14.6298
            Z"
          />
          <path d="M35.421 27.3701
            C34.6726 28.0679 33.7928 28.6096 32.8328 28.9638
            C31.8728 29.3179 30.8519 29.4774 29.8297 29.433
            C28.6344 29.4911 27.4428 29.2598 26.3559 28.7589
            C25.2691 28.2581 24.3192 27.5023 23.5869 26.5559
            C21.2798 23.8416 21.4426 18.6302 21.4426 14.7489
            C21.4426 10.8675 21.2798 5.62895 23.5869 2.86041
            C24.3263 1.91677 25.2821 1.16512 26.3735 0.669045
            C27.4649 0.172967 28.6597 -0.0529391 29.8568 0.0104393
            C30.8534 -0.024332 31.8469 0.140219 32.7791 0.494443
            C33.7113 0.848667 34.5633 1.38544 35.2853 2.07327
            C37.0001 3.77767 37.9751 6.08848 37.9996 8.50606
            H32.2182
            C32.2356 7.73275 32.0875 6.96466 31.7839 6.25323
            C31.5885 5.91506 31.3076 5.63426 30.9693 5.43904
            C30.6311 5.24382 30.2474 5.14105 29.8568 5.14105
            C29.4663 5.14105 29.0826 5.24382 28.7443 5.43904
            C28.406 5.63426 28.1251 5.91506 27.9297 6.25323
            C27.2302 8.99964 26.9736 11.8401 27.1697 14.6674
            C26.9733 17.4858 27.2299 20.3174 27.9297 23.0545
            C28.1232 23.3991 28.405 23.6859 28.746 23.8856
            C29.0871 24.0853 29.4752 24.1905 29.8704 24.1905
            C30.2656 24.1905 30.6537 24.0853 30.9948 23.8856
            C31.3358 23.6859 31.6176 23.3991 31.8111 23.0545
            C32.1157 22.352 32.2727 21.5944 32.2725 20.8288
            H37.9996
            C38.0224 23.2614 37.0976 25.6074 35.421 27.3701
            Z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-facebook"
          id="facebook"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-facebook">Facebook</title>
          <path d="M22.7,0
            H1.3
            C0.6,0,0,0.6,0,1.3
            v21.3
            C0,23.4,0.6,24,1.3,24
            h11.5
            v-9.3
            H9.7
            v-3.6
            h3.1
            V8.4
            c0-3.1,1.9-4.8,4.7-4.8
            c1.3,0,2.5,0.1,2.8,0.1
            V7
            h-1.9
            c-1.5,0-1.8,0.7-1.8,1.8
            v2.3
            h3.6
            l-0.5,3.6
            h-3.1
            V24
            h6.1
            c0.7,0,1.3-0.6,1.3-1.3
            V1.3
            C24,0.6,23.4,0,22.7,0
            z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-twitter"
          id="twitter"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-twitter">Twitter</title>
          <path d="M24,4.6
            c-0.9,0.4-1.8,0.7-2.8,0.8
            c1-0.6,1.8-1.6,2.2-2.7
            c-0.9,0.6-2,1-3.1,1.2
            c-0.9-1-2.2-1.6-3.6-1.6
            c-2.7,0-4.9,2.2-4.9,4.9
            c0,0.4,0,0.8,0.1,1.1
            C7.7,8.1,4.1,6.1,1.7,3.1
            C1.2,3.9,1,4.7,1,5.6
            c0,1.7,0.9,3.2,2.2,4.1
            C2.4,9.7,1.6,9.5,1,9.1
            c0,0,0,0,0,0.1
            c0,2.4,1.7,4.4,3.9,4.8
            c-0.4,0.1-0.8,0.2-1.3,0.2
            c-0.3,0-0.6,0-0.9-0.1
            c0.6,2,2.5,3.4,4.6,3.4
            c-1.7,1.3-3.8,2.1-6.1,2.1
            c-0.4,0-0.8,0-1.2-0.1
            c2.2,1.4,4.8,2.2,7.6,2.2
            c9.1,0,14-7.5,14-14
            c0-0.2,0-0.4,0-0.6
            C22.5,6.4,23.3,5.5,24,4.6
            z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-xdotcom"
          id="xdotcom"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-xdotcom">X</title>
          <path d="M14.095479,10.316482
            L22.286354,1
            h-1.940718
            l-7.115352,8.087682
            L7.551414,1
            H1
            l8.589488,12.231093
            L1,23
            h1.940717
            l7.509372-8.542861
            L16.448587,23
            H23
            L14.095479,10.316482
            z
            M11.436522,13.338465
            l-0.871624-1.218704
            l-6.924311-9.68815
            h2.981339
            l5.58978,7.82155
            l0.867949,1.218704
            l7.26506,10.166271
            h-2.981339
            L11.436522,13.338465
            z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-youtube"
          id="youtube"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-youtube">YouTube</title>
          <path d="M23.5,6.2
            c-0.3-1-1.1-1.9-2.1-2.1
            C19.5,3.5,12,3.5,12,3.5
            s-7.5,0-9.4,0.5
            c-1,0.3-1.8,1.1-2.1,2.1
            C0,8.1,0,12,0,12
            s0,3.9,0.5,5.8
            c0.3,1,1.1,1.9,2.1,2.1
            c1.9,0.5,9.4,0.5,9.4,0.5
            s7.5,0,9.4-0.5
            c1-0.3,1.8-1.1,2.1-2.1
            C24,15.9,24,12,24,12
            S24,8.1,23.5,6.2
            z
            M9.5,15.6
            V8.4
            l6.3,3.6
            L9.5,15.6
            z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-instagram"
          id="instagram"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-instagram">Instagram</title>
          <path clipRule="evenodd"
            d="M21.2,10.2
            h-2.1
            c0.2,0.6,0.2,1.2,0.2,1.8
            c0,4.1-3.3,7.4-7.4,7.4
            c-4.1,0-7.4-3.3-7.4-7.4
            c0-0.6,0.1-1.3,0.2-1.8
            H2.8
            v10.1
            c0,0.5,0.4,0.9,0.9,0.9
            h16.6
            c0.5,0,0.9-0.4,0.9-0.9
            V10.2
            z
            M21.2,3.7
            c0-0.5-0.4-0.9-0.9-0.9
            h-2.8
            c-0.5,0-0.9,0.4-0.9,0.9
            v2.8
            c0,0.5,0.4,0.9,0.9,0.9
            h2.8
            c0.5,0,0.9-0.4,0.9-0.9
            V3.7
            z
            M12,7.4
            c-2.5,0-4.6,2.1-4.6,4.6
            c0,2.5,2.1,4.6,4.6,4.6
            c2.5,0,4.6-2.1,4.6-4.6
            C16.6,9.5,14.5,7.4,12,7.4
            M21.2,24
            H2.8
            C1.3,24,0,22.7,0,21.2
            V2.8
            C0,1.3,1.3,0,2.8,0
            h18.4
            C22.7,0,24,1.3,24,2.8
            v18.4
            C24,22.7,22.7,24,21.2,24"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-help"
          id="help"
          viewBox="0 0 38 38"
        >
          <title id="icon-title-help">Help</title>
          <path clipRule="evenodd"
            d="M19 3.8
            C10.6053 3.8 3.8 10.6053 3.8 19
            C3.8 27.3947 10.6053 34.2 19 34.2
            C27.3947 34.2 34.2 27.3947 34.2 19
            C34.2 10.6053 27.3947 3.8 19 3.8
            Z
            M0 19
            C0 8.50659 8.50659 0 19 0
            C29.4934 0 38 8.50659 38 19
            C38 29.4934 29.4934 38 19 38
            C8.50659 38 0 29.4934 0 19
            Z"
            fillRule="evenodd"
          />
          <path d="M20.9 28.5
            C20.9 29.5494 20.0493 30.4 19 30.4
            C17.9506 30.4 17.1 29.5494 17.1 28.5
            C17.1 27.4507 17.9506 26.6 19 26.6
            C20.0493 26.6 20.9 27.4507 20.9 28.5
            Z"
          />
          <path clipRule="evenodd"
            d="M16.5768 12.4689
            C16.1158 13.1092 15.9436 13.9345 15.9436 14.4566
            V15.2
            C15.9436 16.2494 15.0929 17.1 14.0436 17.1
            C12.9942 17.1 12.1436 16.2494 12.1436 15.2
            V14.4566
            C12.1436 13.3264 12.467 11.6735 13.4929 10.2486
            C14.5887 8.7267 16.3982 7.60004 19.0001 7.60004
            C20.1302 7.60004 21.7831 7.92345 23.2081 8.94943
            C24.7299 10.0452 25.8566 11.8547 25.8566 14.4566
            C25.8566 14.4638 25.8566 14.4712 25.8566 14.4789
            C25.8569 15.3006 25.8583 18.7278 22.328 20.4929
            C21.2103 21.0518 21.0778 21.2322 21.0461 21.2823
            C21.0204 21.323 20.9001 21.5315 20.9001 22.8
            C20.9001 23.8494 20.0494 24.7 19.0001 24.7
            C17.9507 24.7 17.1001 23.8494 17.1001 22.8
            C17.1001 21.5903 17.1535 20.3283 17.8342 19.2516
            C18.5089 18.1844 19.6155 17.6007 20.6286 17.0941
            C22.0219 16.3975 22.0566 15.1637 22.0566 14.4566
            C22.0566 13.0932 21.5311 12.4245 20.9877 12.0333
            C20.3475 11.5723 19.5221 11.4 19.0001 11.4
            C17.6367 11.4 16.968 11.9255 16.5768 12.4689
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-connections"
          id="connections"
          viewBox="0 0 22 22"
        >
          <title id="icon-title-connections">Connections</title>
          <path d="M18.9,11
            L18.9,11
            c0,1.7-1.1,3.1-2.9,3.1
            c-1.8,0-2.9-1.4-2.9-3.1
            v0
            c0-1.7,1.1-3.1,2.9-3.1
            C17.7,7.9,18.9,9.3,18.9,11
            z
            M22,11
            c0-3.2-2.6-5.8-6-5.8
            c-3.5,0-6.1,2.6-6.1,5.8
            v0
            c0,0.1,0,0.2,0,0.3
            c-0.4,0.5-0.8,1.1-1.6,1.8
            c-0.7,0.6-1.4,1-2.3,1
            c-1.7,0-2.8-1.4-2.8-3.1
            v0
            c0-1.7,1.1-3.1,2.7-3.1
            c1.1,0,1.7,0.4,2.4,1.1
            C8.5,8,9,7.1,9.6,6.3
            C8.7,5.6,7.5,5.2,5.9,5.2
            C2.4,5.2,0,7.8,0,11
            v0
            c0,3.2,2.5,5.8,5.8,5.8
            c1.7,0,2.8-0.5,3.7-1.2
            c0.3-0.3,0.9-0.7,1.4-1.3
            c1.1,1.5,2.9,2.5,5,2.5
            C19.4,16.8,22,14.2,22,11
            L22,11
            z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-rewards"
          id="rewards"
          viewBox="0 0 22 22"
        >
          <title id="icon-title-rewards">Rewards</title>
          <path className="st0"
            d="M20.7,12
            l1.3-1
            l-1.3-1
            l1-1.3
            L20.3,8
            L21,6.5
            l-1.6-0.4
            l0.4-1.6
            l-1.6-0.1
            l0.1-1.6
            L16.7,3
            l-0.2-1.6
            L15,2
            l-0.6-1.5
            L13,1.4
            L12.1,0
            L11,1.2
            L9.9,0
            L9,1.4
            L7.6,0.5
            L7,2
            L5.5,1.4
            L5.3,3
            L3.6,2.8
            l0.1,1.6
            L2.1,4.5
            l0.4,1.6
            L1,6.5
            L1.7,8
            L0.2,8.7
            l1,1.3
            L0,11
            l1.3,1
            l-1,1.3
            L1.7,14
            L1,15.5
            l1.6,0.4
            l-0.4,1.6
            l1.6,0.1
            l-0.1,1.6
            L5.3,19
            l0.2,1.6
            L7,20
            l0.6,1.5
            L9,20.6
            L9.9,22
            l1.1-1.2
            l1.1,1.2
            l0.9-1.4
            l1.4,0.9
            L15,20
            l1.5,0.6
            l0.2-1.6
            l1.6,0.3
            l-0.1-1.6
            l1.6-0.1
            l-0.4-1.6
            l1.6-0.4
            L20.3,14
            l1.5-0.7
            L20.7,12
            z
            M11.4,16.5
            v1.3
            h-0.7
            v-1.3
            c-2.3-0.1-4.3-1.1-4.3-3.7
            h2.7
            c0.1,1.1,0.6,1.5,1.6,1.6
            v-2.3
            c-0.3-0.1-0.6-0.2-0.9-0.3
            c-1.5-0.4-3.1-1.1-3.1-3
            c0-2.3,2.1-3.2,4-3.3
            V4.2
            h0.7
            v1.3
            c2,0.1,3.8,1.2,3.8,3.4
            h-2.7
            c0-0.8-0.4-1.1-1.1-1.3
            v2
            c0.3,0.1,0.7,0.2,1.1,0.3
            c1.5,0.4,3,1.1,3,3
            C15.6,15.5,13.6,16.4,11.4,16.5
            z"
            id="XMLID_17652_"
          />
          <path className="st0"
            d="M9.5,8.6c0,0.5,0.5,0.7,1.3,0.9V7.6C10.2,7.6,9.5,7.9,9.5,8.6z"
            id="XMLID_17651_"
          />
          <path className="st0"
            d="M11.4,12.3v2.1c0.6,0,1.4-0.3,1.4-1C12.8,12.8,12.3,12.5,11.4,12.3z"
            id="XMLID_17619_"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-history"
          id="history"
          viewBox="0 0 17 17"
        >
          <title id="icon-title-history">History</title>
          <path clipRule="evenodd"
            d="M12.2457 2.82
            C11.017 2.01022 9.55858 1.62121 8.0898 1.71148
            C6.62102 1.80175 5.22125 2.36641 4.10095 3.32055
            C3.74384 3.6247 3.20778 3.58176 2.90363 3.22465
            C2.59949 2.86754 2.64242 2.33148 2.99953 2.02734
            C4.39991 0.834657 6.14963 0.128834 7.9856 0.0160002
            C9.82157 -0.0968338 11.6446 0.389419 13.1804 1.40164
            C14.7163 2.41387 15.8821 3.89735 16.5024 5.62902
            C17.1228 7.3607 17.1642 9.24696 16.6204 11.0042
            C16.0766 12.7614 14.9771 14.2946 13.4871 15.3733
            C11.9971 16.4519 10.1972 17.0177 8.35807 16.9855
            C6.51891 16.9533 4.73991 16.325 3.28855 15.1949
            C1.8372 14.0648 0.791942 12.4941 0.309958 10.7189
            C0.187046 10.2662 0.454383 9.79961 0.907071 9.6767
            C1.35976 9.55379 1.82638 9.82112 1.94929 10.2738
            C2.33487 11.6939 3.17108 12.9505 4.33216 13.8546
            C5.49325 14.7587 6.91645 15.2614 8.38778 15.2871
            C9.8591 15.3128 11.299 14.8602 12.491 13.9973
            C13.683 13.1344 14.5626 11.9078 14.9976 10.502
            C15.4327 9.09625 15.3995 7.58724 14.9033 6.2019
            C14.407 4.81656 13.4744 3.62978 12.2457 2.82
            Z"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M0.911855 0.686565
            C1.38089 0.692947 1.75594 1.07835 1.74956 1.54738
            L1.71016 4.44371
            L4.60648 4.48311
            C5.07552 4.4895 5.45057 4.8749 5.44419 5.34393
            C5.43781 5.81296 5.05241 6.18802 4.58337 6.18164
            L0.837786 6.13068
            C0.612547 6.12761 0.397752 6.0352 0.240651 5.87376
            C0.0835508 5.71233 -0.00298576 5.4951 7.87015e-05 5.26986
            L0.0510391 1.52427
            C0.0574204 1.05524 0.442821 0.680184 0.911855 0.686565
            Z"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M8.51039 2.75888
            C8.97946 2.75888 9.35973 3.13914 9.35973 3.60822
            V7.64258
            H11.7294
            C12.1985 7.64258 12.5787 8.02284 12.5787 8.49192
            C12.5787 8.961 12.1985 9.34126 11.7294 9.34126
            H7.66105
            V3.60822
            C7.66105 3.13914 8.04131 2.75888 8.51039 2.75888
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol fill="none"
          id="warning"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path clipRule="evenodd"
            d="M11.1722 4.58919
            L3.57287 18.488
            L3.56821 18.4962
            C3.15567 19.2181 3.65462 20 4.39996 20
            H19.6
            C20.3453 20 20.8443 19.2181 20.4317 18.4962
            L20.4257 18.4856
            L12.9265 4.58714
            C12.5092 3.87033 11.5885 3.87102 11.1722 4.58919
            Z
            M9.43172 3.60391
            C10.6156 1.5321 13.4843 1.5321 14.6682 3.60391
            L14.6742 3.61448
            L22.1748 17.5154
            C23.3501 19.5909 21.8505 22 19.6 22
            H4.39996
            C2.14851 22 0.648535 19.5888 1.82667 17.5128
            L9.42706 3.61207
            L9.43172 3.60391
            Z"
            fill="#DD0000"
            fillRule="evenodd"
          />
          <path d="M13 17
            C13 17.5523 12.5523 18 12 18
            C11.4477 18 11 17.5523 11 17
            C11 16.4477 11.4477 16 12 16
            C12.5523 16 13 16.4477 13 17
            Z"
          fill="#DD0000"
          />
          <path clipRule="evenodd"
            d="M12 18
            C12.5523 18 13 17.5523 13 17
            C13 16.4477 12.5523 16 12 16
            C11.4477 16 11 16.4477 11 17
            C11 17.5523 11.4477 18 12 18
            Z"
            fill="#DD0000"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M12 8
            C12.5523 8 13 8.44772 13 9
            L13 14
            C13 14.5523 12.5523 15 12 15
            C11.4477 15 11 14.5523 11 14
            L11 9
            C11 8.44772 11.4477 8 12 8
            Z"
            fill="#DD0000"
            fillRule="evenodd"
          />

        </symbol>

        <symbol fill="none"
          id="warning-filled"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M19.6 21
            H4.39998
            C2.89998 21 1.89998 19.4 2.69998 18
            L10.3 4.10005
            C11.1 2.70005 13 2.70005 13.8 4.10005
            L21.3 18
            C22.1 19.4 21.1 21 19.6 21
            Z"
          fill="#DD0000"
          stroke="#DD0000"
          strokeMiterlimit="10"
          strokeWidth="2"
          />
          <circle cx="12"
            cy="17.5"
            fill="#FAFAFA"
            r="1"
            stroke="#FAFAFA"
          />
          <path d="M12 8L12 13"
            stroke="#FAFAFA"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />

        </symbol>

        <symbol aria-labelledby="icon-title-checkmark"
          id="checkmark"
          viewBox="-132.8 390 16.8 14"
        >
          <title id="icon-title-checkmark">checkmark</title>
          <polygon points="-132.1,398.3 -130.1,396.2 -127.2,399.2 -118.7,390.7 -116.7,392.8 -127.2,403.3 	" />
        </symbol>

        <symbol fill="none"
          id="checkmarkGreen"
          viewBox="0 0 17 13"
        >
          <path d="M2 6.98926L5.734 10.6743"
            stroke="#28AA00"
            strokeLinecap="round"
            strokeWidth="3"
          />
          <path d="M14.9469 1.5L5.81787 10.568"
            stroke="#28AA00"
            strokeLinecap="round"
            strokeWidth="3"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-series"
          id="series"
          viewBox="0 0 22 22"
        >
          <title id="icon-title-series">Event Series</title>
          <path d="M18.247,0
            v0.466
            c0,0.831-0.742,1.506-1.654,1.506
            s-1.654-0.675-1.654-1.506
            V0
            h-3.705
            v5.679
            C11.156,5.689,11.08,5.701,11,5.701
            c-0.912,0-1.654-0.675-1.654-1.506
            V3.728
            H5.641
            v5.679
            c-0.077,0.01-0.153,0.021-0.233,0.021
            c-0.912,0-1.654-0.675-1.654-1.506
            V7.456
            H0.048
            V22
            h3.705
            v-0.466
            c0-0.831,0.742-1.506,1.654-1.506
            s1.654,0.675,1.654,1.506
            V22
            h3.705
            v-5.672
            c0.077-0.011,0.152-0.029,0.233-0.029
            c0.912,0,1.654,0.675,1.654,1.506
            v0.466
            h3.705
            v-5.661
            c0.079-0.011,0.151-0.04,0.233-0.04
            c0.912,0,1.654,0.675,1.654,1.506
            v0.466
            h3.705
            V0
            H18.247
            z
            M9.835,21.068
            H7.947
            c-0.231-1.122-1.282-1.972-2.539-1.972
            s-2.308,0.85-2.539,1.972
            H0.98
            V8.389
            h1.888
            c0.231,1.122,1.282,1.972,2.539,1.972
            s2.308-0.85,2.539-1.972
            h1.888
            V21.068
            z
            M15.427,17.34
            h-1.888
            c-0.231-1.122-1.282-1.972-2.539-1.972
            c-0.081,0-0.155,0.021-0.233,0.029
            v-7.94
            H7.062
            v0.466
            c0,0.417-0.187,0.795-0.489,1.068
            V4.66
            h1.888
            C8.692,5.783,9.743,6.633,11,6.633
            s2.308-0.85,2.539-1.972
            h1.888
            V17.34
            z
            M21.02,13.611
            h-1.888
            c-0.231-1.122-1.282-1.972-2.539-1.972
            c-0.08,0-0.155,0.018-0.233,0.026
            V3.728
            h-3.705
            v0.466
            c0,0.417-0.187,0.795-0.489,1.068
            v-4.33
            h1.888
            c0.231,1.122,1.282,1.972,2.539,1.972
            s2.308-0.85,2.539-1.972
            h1.888
            V13.611
            z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-series-solid"
          id="series-solid"
          viewBox="0 0 22 22"
        >
          <title id="icon-title-series-solid">Event Series</title>
          <path d="M6.298,10.059
            C6.266,11.136,5.389,12,4.304,12
            c-1.084,0-1.962-0.864-1.994-1.941
            H0
            v12
            h2.31
            C2.31,22.039,2.304,22.02,2.304,22
            c0-1.105,0.895-2,2-2
            c1.105,0,2,0.895,2,2
            c0,0.02-0.005,0.039-0.006,0.059
            h2.31
            v-12
            H6.298
            z"
          />
          <path d="M19.696,0
            c0,1.105-0.895,2-2,2
            c-1.105,0-2-0.895-2-2
            h-2.304
            v4
            h2.913
            v6.567
            c0.36-0.35,0.85-0.567,1.391-0.567
            c1.105,0,2,0.895,2,2
            H22
            V0
            H19.696
            z"
          />
          <path d="M13,5
            c0,1.105-0.895,2-2,2
            S9,6.105,9,5
            H6.696
            v4.059
            h2.913
            v6.508
            C9.969,15.217,10.458,15,11,15
            c1.105,0,2,0.895,2,2
            h2.304
            V5
            H13
            z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-location"
          id="location"
          viewBox="0 0 22 22"
        >
          <title id="icon-title-location">Location</title>
          <path d="M11,1.29
            c-4.42,0-7.88,3.46-7.88,7.88
            c0,4.6,6.27,11.08,7.88,11.08
            c1.84,0,7.88-6.73,7.88-11.08
            C18.88,4.75,15.42,1.29,11,1.29
            z
            M11,18.17
            c-1.3-0.85-5.87-5.57-5.87-9
            c0-3.29,2.58-5.88,5.88-5.88
            c3.29,0,5.88,2.58,5.88,5.88
            C16.88,12.59,12.3,17.32,11,18.17
            z"
          />
          <path d="M11,5.88
            c-1.81,0-3.29,1.48-3.29,3.29
            s1.48,3.29,3.29,3.29
            c1.82,0,3.29-1.48,3.29-3.29
            S12.82,5.88,11,5.88
            z
            M11,10.46
            c-0.71,0-1.29-0.58-1.29-1.29
            S10.29,7.88,11,7.88
            c0.71,0,1.29,0.58,1.29,1.29
            S11.71,10.46,11,10.46
            z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-plus"
          id="plus"
          viewBox="0 0 22 22"
        >
          <title id="icon-title-plus">Plus</title>
          <polygon points={`18.083,12.417 12.417,12.417 12.417,18.083 9.583,18.083 9.583,12.417 3.917,12.417 3.917,9.583 9.583,9.583
9.583,3.917 12.417,3.917 12.417,9.583 18.083,9.583`}
          />
        </symbol>

        <symbol aria-labelledby="icon-title-minus"
          id="minus"
          viewBox="0 0 22 22"
        >
          <title id="icon-title-minus">Minus</title>
          <rect height="2.833"
            width="13.167"
            x="4.417"
            y="9.583"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-movierewards"
          fill="none"
          id="movierewards"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-movierewards">Movie Rewards</title>
          <g clipPath="url(#clip0_2088_17264)">
            <g clipPath="url(#clip1_2088_17264)">
              <path d="M13.58 3
            L13.42 3.44
            C13.2 4.03 12.63 4.43 12 4.43
            C11.37 4.43 10.8 4.03 10.58 3.44
            L10.42 3
            H4
            V21
            H10.42
            L10.58 20.56
            C10.8 19.97 11.37 19.57 12 19.57
            C12.63 19.57 13.2 19.97 13.42 20.56
            L13.58 21
            H20
            V3
            H13.58
            Z
            M18.66 19.66
            H14.47
            C13.97 18.79 13.03 18.23 12 18.23
            C10.97 18.23 10.03 18.79 9.53 19.66
            H5.34
            V4.34
            H9.53
            C10.03 5.21 10.97 5.77 12 5.77
            C13.03 5.77 13.97 5.21 14.47 4.34
            H18.66
            V19.66
            Z"
              fill="currentColor"
              />
              <path d="M12.95 11.12
            L12 8.20001
            L11.05 11.12
            H7.97998
            L10.46 12.92
            L9.51998 15.85
            L12 14.04
            L14.48 15.85
            L13.54 12.92
            L16.02 11.12
            H12.95
            Z"
              fill="currentColor"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_2088_17264">
              <rect fill="white"
                height="24"
                width="24"
              />
            </clipPath>
            <clipPath id="clip1_2088_17264">
              <rect fill="white"
                height="18"
                transform="translate(4 3)"
                width="16"
              />
            </clipPath>
          </defs>
        </symbol>

        <symbol aria-labelledby="icon-title-candy"
          id="candy"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-candy">Candy</title>
          <path clipRule="evenodd"
            d="M16.79,2.28
            c-0.21-0.64-0.83-1.06-1.5-1.03
            c-0.65,0.03-1.21,0.47-1.38,1.1
            l-0.96,3.42
            c-0.5-0.15-1.02-0.22-1.57-0.22
            c-3.03,0-5.59,2.56-5.59,5.59
            c0,0.76,0.15,1.48,0.42,2.13
            l-3.18,0.87
            c-0.91,0.25-1.41,1.22-1.08,2.11
            c0.15,0.4,0.45,0.72,0.84,0.9
            l1.66,0.76
            l0.36,1.66
            c0.14,0.66,0.71,1.14,1.38,1.19
            c0.65,0.04,1.25-0.34,1.49-0.94
            l1.43-3.56
            c0.7,0.31,1.46,0.48,2.27,0.48
            c3.13,0,5.59-2.56,5.59-5.59
            c0-0.91-0.22-1.78-0.62-2.55
            l2.8-1.1
            c0.88-0.34,1.27-1.37,0.85-2.21
            c-0.19-0.38-0.52-0.67-0.93-0.8
            l-1.74-0.58
            L16.79,2.28
            z
            M14.83,6.44
            l0.56-2.01
            l0.03,0.09
            c0.2,0.6,0.67,1.07,1.26,1.26
            l0.7,0.23
            l-2.03,0.8
            L14.83,6.44
            z
            M11.37,7.44
            c2.08,0,3.69,1.71,3.69,3.69
            c0,2.08-1.71,3.69-3.69,3.69
            c-1.99,0-3.69-1.61-3.69-3.69
            C7.68,9.15,9.38,7.44,11.37,7.44
            z
            M6.42,17.57
            l0.78-1.94
            L6.7,15.21
            l-2.1,0.57
            l0.67,0.31
            c0.57,0.26,0.99,0.78,1.12,1.39
            L6.42,17.57
            z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-popcorn"
          id="popcorn2"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-popcorn">Popcorn</title>
          <path d="M21.61,6.59
            a2.13,2.13,0,0,0-1.7-.87
            h-.15
            a3,3,0,0,0-3-2.84,3,3,0,0,0-2,.79,3.26,3.26,0,0,0-5.54,0,3,3,0,0,0-2-.79,3,3,0,0,0-3,2.84
            H4.09
            a2.13,2.13,0,0,0-1.7.87,2.08,2.08,0,0,0-.28,1.89
            l4,12
            a2.11,2.11,0,0,0,2,1.44
            h7.84
            a2.11,2.11,0,0,0,2-1.44
            l4-11.95
            A2.09,2.09,0,0,0,21.61,6.59
            Z
            M16.78,4.67
            a1.2,1.2,0,0,1,1.17,1
            H15.62
            A1.19,1.19,0,0,1,16.78,4.67
            Z
            m-.89,15.4
            h-3
            V7.52
            h3
            Z
            M8.11,7.52
            h3
            V20.07
            h-3
            Z
            M12,3.93
            a1.49,1.49,0,0,1,1.49,1.49
            c0,.15,0,.3,0,.3
            h-3
            a2,2,0,0,1,0-.3
            A1.49,1.49,0,0,1,12,3.93
            Z
            m-4.78.74
            a1.19,1.19,0,0,1,1.16,1
            H6.05
            A1.2,1.2,0,0,1,7.22,4.67
            Z
            M3.81,7.91
            a.31.31,0,0,1,0-.27.28.28,0,0,1,.24-.12
            H6.32
            v7.92
            Z
            m16.38,0-2.51,7.53
            V7.52
            h2.23
            a.28.28,0,0,1,.24.12
            A.31.31,0,0,1,20.19,7.91
            Z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-drink"
          id="drink"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-drink">Drink</title>
          <path d="M20.5,7.9
            h-3.4
            H13
            V6.1
            l3.9-2.9
            c0.4-0.3,0.5-0.9,0.2-1.3
            c-0.3-0.4-0.9-0.5-1.3-0.2
            l-4.2,3.2
            C11.2,5.1,11,5.3,11,5.6
            v2.2
            H6.9
            H3.5
            c-0.5,0-1,0.4-1,1
            s0.4,1,1,1
            h1.4
            c0,0.1,0,0.3,0,0.4
            l1.8,10.6
            c0.2,1,1,1.7,2,1.7
            h6.7
            c1,0,1.8-0.7,2-1.7
            l1.8-10.6
            c0-0.1,0-0.3,0-0.4
            h1.4
            c0.5,0,1-0.4,1-1
            S21,7.9,20.5,7.9
            z
            M17.2,9.9
            l-1.8,10.6
            c0,0.1-0.1,0.1-0.1,0.1
            H8.7
            c-0.1,0-0.1,0-0.1-0.1
            L6.8,9.9
            l0.1-0.1
            h10.2
            L17.2,9.9
            z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-hotdog"
          id="hotdog"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-hotdog">Hot Dog</title>
          <path d="M22,5.2
            c0-0.8-0.3-1.5-0.9-2.1
            c-1-1-2.8-1.1-3.9-0.2
            C16.6,2.3,15.8,2,15,2
            c-0.9,0-1.7,0.3-2.3,1
            l-9.7,9.7
            c-0.6,0.6-1,1.4-1,2.3
            c0,0.8,0.3,1.6,0.9,2.2
            c-0.4,0.5-0.6,1.2-0.6,1.8
            c0,0.8,0.3,1.5,0.9,2.1
            C3.7,21.7,4.4,22,5.2,22
            c0.7,0,1.4-0.3,1.9-0.7
            c0.5,0.3,1,0.4,1.6,0.4
            c0.9,0,1.7-0.3,2.3-1
            l9.7-9.7
            c1-1,1.2-2.6,0.5-3.9
            C21.8,6.6,22,5.9,22,5.2
            z
            M19.8,9
            l-0.2,0
            c0,0.1-0.1,0.2-0.1,0.3
            l0,0
            c-0.1,0.1-0.1,0.2-0.2,0.2
            l-9.7,9.7
            c-0.1,0.1-0.1,0.1-0.2,0.2
            l-0.1,0
            c-0.1,0-0.2,0.1-0.2,0.1
            l0,0
            c-0.2,0.1-0.4,0-0.6,0
            c-0.2-0.1-0.4-0.2-0.6-0.3
            l-0.7-0.7
            c-0.2-0.2-0.4-0.6-0.4-0.9
            s0.1-0.7,0.4-0.9
            l9.7-9.7
            c0.2-0.2,0.6-0.4,0.9-0.4
            c0.3,0,0.7,0.1,0.9,0.4
            l0.7,0.7
            c0.3,0.3,0.4,0.8,0.3,1.2
            L19.8,9
            z
            M15.8,4.3
            L4.3,15.8
            C4.1,15.6,4,15.3,4,15
            c0-0.3,0.1-0.7,0.4-0.9
            l9.7-9.7
            C14.3,4.1,14.6,4,15,4
            C15.3,4,15.6,4.1,15.8,4.3
            z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-pizza"
          id="pizza"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-pizza">Pizza</title>
          <path d="M19.7,3
            c-2.4-1-5-1.5-7.6-1.5
            c0,0,0,0,0,0
            l-0.2,0
            C9.2,1.5,6.7,2,4.3,3
            C4.1,3.1,3.9,3.3,3.8,3.6
            s-0.1,0.5,0,0.8
            l7.3,17.6
            c0.2,0.4,0.5,0.6,0.9,0.6
            s0.8-0.2,0.9-0.6
            l7.3-17.6
            C20.4,3.8,20.2,3.2,19.7,3
            z
            M7.6,8.3
            C8.1,8,8.8,8,9.2,8.4
            c0.2,0.2,0.4,0.5,0.4,0.9
            s-0.1,0.6-0.4,0.9
            c-0.2,0.2-0.5,0.3-0.7,0.3
            L7.6,8.3
            z
            M12,18.9
            l-2.9-7
            c0.4-0.1,0.9-0.3,1.2-0.7
            c0.5-0.5,0.8-1.2,0.8-1.9
            s-0.3-1.4-0.8-1.9
            C9.4,6.5,8.1,6.4,7,6.9
            L6,4.5
            c1.9-0.7,3.8-1,5.8-1
            l0.2,0
            c0,0,0,0,0,0
            c2,0,4,0.3,5.9,1
            l-0.3,0.7
            c-1.8-0.6-3.7-1-5.6-1
            c0,0,0,0,0,0
            l-0.2,0
            c-0.8,0-1.6,0.1-2.3,0.2
            C9.1,4.5,8.8,4.9,8.9,5.3
            C8.9,5.7,9.3,6,9.7,6
            c0.7-0.1,1.4-0.2,2.1-0.2
            l0.2,0
            c0,0,0,0,0,0
            c1.7,0,3.4,0.3,5.1,0.9
            l-1.7,4.2
            c-0.4-0.2-0.9-0.4-1.4-0.4
            c-1.5,0-2.7,1.2-2.7,2.7
            c0,1.3,0.9,2.3,2,2.6
            L12,18.9
            z
            M13.9,14.4
            c-0.6-0.1-1.1-0.6-1.1-1.2
            c0-0.7,0.5-1.2,1.2-1.2
            c0.3,0,0.6,0.1,0.8,0.3
            L13.9,14.4
            z"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-icecream"
          id="icecream"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-icecream">Ice Cream</title>
          <path d="M19,10.5
            c0-0.5-0.1-0.9-0.3-1.3
            c0-0.3,0.1-0.6,0.1-0.9
            c0-3.7-3.1-6.8-6.8-6.8
            S5.2,4.6,5.2,8.3
            c0,0.3,0,0.6,0.1,0.9
            C5.1,9.6,5,10.1,5,10.5
            c0,1.5,1.2,2.8,2.7,3
            l3.5,8.4
            c0.2,0.4,0.5,0.6,0.9,0.6
            s0.8-0.2,0.9-0.6
            l3.5-8.4
            C17.9,13.4,19,12.1,19,10.5
            z
            M12,18.9
            l-1.7-4
            c0.5,0.1,1.1,0.2,1.7,0.2
            s1.1-0.1,1.7-0.2
            L12,18.9
            z
            M16,11.6
            c-0.2,0-0.3,0-0.4-0.1
            c-0.9,1-2.2,1.6-3.6,1.6
            s-2.7-0.6-3.6-1.6
            c-0.1,0.1-0.3,0.1-0.4,0.1
            c-0.6,0-1-0.5-1-1
            c0-0.3,0.2-0.7,0.4-0.8
            C7.3,9.3,7.2,8.8,7.2,8.3
            c0-2.7,2.1-4.8,4.8-4.8
            s4.8,2.1,4.8,4.8
            c0,0.5-0.1,1-0.2,1.4
            c0.3,0.2,0.4,0.5,0.4,0.8
            C17,11.1,16.6,11.6,16,11.6
            z"
          />
        </symbol>

        <symbol fill="none"
          id="restaurant"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M14 20
            V4
            C14 3.44772 14.4673 2.97852 14.9729 3.20082
            C17.5136 4.318 18.077 9.84016 18.0222 13.2675
            C18.0156 13.6775 17.6771 14 17.267 14
            C16.8434 14 16.5 14.3434 16.5 14.767
            V20
            C16.5 20.5523 16.0523 21 15.5 21
            H15
            C14.4477 21 14 20.5523 14 20
            Z"
          stroke="currentColor"
          strokeWidth="1.5"
          />
          <path d="M11 3
            V10
            C11 10.5233 10.893 10.8826 10.7315 11.1234
            C10.3513 11.6902 9.5 12.2049 9.5 12.8874
            V20
            C9.5 20.5523 9.05228 21 8.5 21
            H8
            C7.44772 21 7 20.5523 7 20
            V12.7808
            C7 12.1302 6.33354 11.6893 5.74573 11.4105
            C5.33106 11.2138 5 10.7973 5 10
            V3"
          stroke="currentColor"
          strokeLinecap="round"
          strokeWidth="1.5"
          />
          <path d="M8 3V9.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
          />

        </symbol>

        <symbol fill="none"
          id="bar"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M16 6V19C16 20.1046 15.1046 21 14 21H7C5.89543 21 5 20.1046 5 19V15.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path d="M17 10H18C19.1046 10 20 10.8954 20 12V14C20 15.1046 19.1046 16 18 16H17"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path d="M9.4209 2.25
            C9.59372 2.25 10.212 2.24757 10.8516 2.44629
            C11.1715 2.54575 11.5348 2.70982 11.8525 2.97363
            C12.2294 2.71997 12.6935 2.59375 13.1357 2.59375
            C14.0819 2.59381 14.8463 2.84695 15.3047 3.51367
            C15.7107 4.10418 15.75 4.86546 15.75 5.5
            C15.75 5.69891 15.6709 5.88962 15.5303 6.03027
            C15.3896 6.17093 15.1989 6.25 15 6.25
            H7.19434
            V13
            V13.001
            V13.0176
            C7.1942 13.0246 7.19373 13.0329 7.19336 13.042
            C7.19262 13.0601 7.19171 13.0825 7.18945 13.1084
            C7.18494 13.16 7.17609 13.2274 7.16016 13.3057
            C7.12871 13.4601 7.06498 13.6734 6.93164 13.8916
            C6.63565 14.3757 6.08095 14.7499 5.22266 14.75
            C4.36409 14.75 3.80873 14.3758 3.5127 13.8916
            C3.37936 13.6734 3.31563 13.4601 3.28418 13.3057
            C3.26825 13.2274 3.25939 13.16 3.25488 13.1084
            C3.25262 13.0825 3.25172 13.0601 3.25098 13.042
            C3.25061 13.0329 3.25014 13.0246 3.25 13.0176
            V13.001
            C3.25 13.0005 3.25 13 4 13
            H3.25
            V5
            C3.25 4.77389 3.23799 4.27714 3.4834 3.80859
            C3.756 3.28818 4.26283 2.9329 5.00488 2.77148
            C5.29259 2.69442 5.76961 2.66954 6.26074 2.80664
            C6.53117 2.88214 6.81435 3.01031 7.07812 3.20898
            C7.28912 3.0066 7.52222 2.84103 7.75293 2.71289
            C8.28922 2.41502 8.90669 2.25002 9.4209 2.25
            Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          />
          <path d="M9.5 10V18"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path d="M12.5 10V18"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="1.5"
          />

        </symbol>

        <symbol aria-labelledby="icon-title-popcorn"
          id="popcorn"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-popcorn">Popcorn</title>
          <path clipRule="evenodd"
            d="M14.0554 5.43546
            C13.6301 5.86077 13.3585 6.41105 13.2763 7
            H10.7236
            C10.6414 6.41105 10.3698 5.86077 9.94452 5.43546
            C9.4288 4.91973 8.72932 4.63 7.99998 4.63
            C7.27063 4.63 6.57116 4.91973 6.05543 5.43546
            C5.62937 5.86152 5.35755 6.41299 5.27592 7.00311
            C4.99815 7.01861 4.72622 7.09193 4.47771 7.21885
            C4.19449 7.3635 3.94986 7.57359 3.76409 7.83171
            C3.57832 8.08983 3.45679 8.38852 3.40956 8.70301
            C3.36246 9.01667 3.39064 9.33702 3.49176 9.63763
            L3.49256 9.64
            L6.8212 19.6359
            L6.8221 19.6386
            C6.96126 20.0526 7.23209 20.4096 7.59323 20.6552
            C7.94595 20.8951 8.36587 21.0157 8.79159 21
            H15.3084
            C15.7341 21.0157 16.154 20.8951 16.5067 20.6552
            C16.8679 20.4096 17.1387 20.0526 17.2778 19.6386
            L17.2788 19.6359
            L20.6074 9.63993
            C20.7153 9.32357 20.7421 8.98519 20.6855 8.65572
            C20.6285 8.32433 20.489 8.01264 20.2796 7.74948
            C20.0703 7.48633 19.798 7.2802 19.4879 7.15016
            C19.2449 7.04826 18.9849 6.99565 18.7228 6.99455
            C18.6398 6.40766 18.3685 5.85946 17.9445 5.43546
            C17.4288 4.91973 16.7293 4.63 16 4.63
            C15.2706 4.63 14.5712 4.91973 14.0554 5.43546
            Z
            M16 6.63
            C15.8011 6.63 15.6103 6.70902 15.4696 6.84967
            C15.4243 6.89504 15.3853 6.94562 15.3534 7
            H16.6466
            C16.6146 6.94562 16.5757 6.89504 16.5303 6.84967
            C16.3897 6.70902 16.1989 6.63 16 6.63
            Z
            M7.35337 7
            H8.64659
            C8.61463 6.94562 8.57567 6.89504 8.53031 6.84967
            C8.38966 6.70902 8.19889 6.63 7.99998 6.63
            C7.80106 6.63 7.6103 6.70902 7.46965 6.84967
            C7.42428 6.89504 7.38533 6.94562 7.35337 7
            Z
            M5.38875 9.00406
            L5.38739 9
            H6.99998
            V13.8426
            L5.38875 9.00406
            Z
            M8.7174 19
            L8.71785 19.0014
            L8.74389 19
            H8.7174
            Z
            M8.99998 19
            H11
            V9
            H8.99998
            V19
            Z
            M15 19
            H13
            V9
            H15
            V19
            Z
            M15.3561 19
            L15.3821 19.0014
            L15.3826 19
            H15.3561
            Z
            M17 14.1429
            L18.7144 8.99454
            L18.6623 9
            H17
            V14.1429
            Z"
            fill="currentColor"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M12 6
            C11.7348 6 11.4804 6.10536 11.2929 6.29289
            C11.11 6.4758 11.0052 6.72226 11.0002 6.98037
            C11.0611 6.98841 11.1441 6.99531 11.2561 6.99897
            C11.4002 7.00368 11.5435 7.00262 11.7135 7.00135
            C11.8007 7.0007 11.895 7 12 7
            C12.105 7 12.1992 7.0007 12.2865 7.00135
            C12.4564 7.00262 12.5997 7.00368 12.7439 6.99897
            C12.8558 6.99531 12.9388 6.98841 12.9998 6.98037
            C12.9947 6.72226 12.89 6.4758 12.7071 6.29289
            C12.5195 6.10536 12.2652 6 12 6
            Z
            M12.9915 7.10656
            L12.9919 7.10487
            L12.9915 7.10656
            Z
            M11.0085 7.10656
            L11.008 7.10488
            L11.0085 7.10656
            Z
            M9.87865 4.87868
            C10.4413 4.31607 11.2043 4 12 4
            C12.7956 4 13.5587 4.31607 14.1213 4.87868
            C14.6839 5.44129 15 6.20435 15 7
            C15 7.40493 14.9174 7.82744 14.6618 8.19318
            C14.3993 8.56872 14.038 8.76542 13.7089 8.86756
            C13.3976 8.96418 13.0745 8.98923 12.8092 8.9979
            C12.6243 9.00395 12.4148 9.00246 12.2227 9.00109
            C12.1446 9.00053 12.0694 9 12 9
            C11.9305 9 11.8553 9.00053 11.7773 9.00109
            C11.5852 9.00246 11.3756 9.00395 11.1907 8.9979
            C10.9254 8.98923 10.6024 8.96418 10.2911 8.86756
            C9.96195 8.76542 9.60061 8.56872 9.33814 8.19318
            C9.08251 7.82744 8.99997 7.40493 8.99997 7
            C8.99997 6.20435 9.31605 5.44129 9.87865 4.87868
            Z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-lock"
          fill="none"
          id="lock"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-lock">Lock</title>
          <path d="M14 16
            C14 17.1046 13.1046 18 12 18
            C10.8954 18 10 17.1046 10 16
            C10 14.8954 10.8954 14 12 14
            C13.1046 14 14 14.8954 14 16
            Z"
          fill="currentColor"
          />
          <path clipRule="evenodd"
            d="M18 10.1707
            V8
            C18 4.68629 15.3137 2 12 2
            C8.68629 2 6 4.68629 6 8
            V10.1707
            C4.83481 10.5825 4 11.6938 4 13
            V19
            C4 20.6569 5.34315 22 7 22
            H17
            C18.6569 22 20 20.6569 20 19
            V13
            C20 11.6938 19.1652 10.5825 18 10.1707
            Z
            M16 8
            C16 5.79086 14.2091 4 12 4
            C9.79086 4 8 5.79086 8 8
            V10
            H16
            V8
            Z
            M6 13
            C6 12.4477 6.44772 12 7 12
            H17
            C17.5523 12 18 12.4477 18 13
            V19
            C18 19.5523 17.5523 20 17 20
            H7
            C6.44772 20 6 19.5523 6 19
            V13
            Z"
            fill="currentColor"
            fillRule="evenodd"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-private"
          fill="none"
          id="private"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-private">Private</title>
          <circle cx="5"
            cy="5"
            r="2"
            stroke="black"
            strokeWidth="1.5"
          />
          <circle cx="19"
            cy="5"
            r="2"
            stroke="black"
            strokeWidth="1.5"
          />
          <path d="M6 6.5C6 6.5 7.5 10 12 10C16.5 10 18 6.5 18 6.5"
            stroke="black"
            strokeWidth="2"
          />
          <path d="M5 7V19"
            stroke="black"
            strokeWidth="2.5"
          />
          <ellipse cx="5"
            cy="19.5"
            fill="black"
            rx="3"
            ry="1.5"
          />
          <path d="M19 7V19"
            stroke="black"
            strokeWidth="2.5"
          />
          <ellipse cx="19"
            cy="19.5"
            fill="black"
            rx="3"
            ry="1.5"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-delete"
          id="delete"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-delete">Delete</title>
          <path d="M12 4
            C16.4 4 20 7.6 20 12
            C20 16.4 16.4 20 12 20
            C7.6 20 4 16.4 4 12
            C4 7.6 7.6 4 12 4
            Z
            M12 2
            C6.5 2 2 6.5 2 12
            C2 17.5 6.5 22 12 22
            C17.5 22 22 17.5 22 12
            C22 6.5 17.5 2 12 2
            Z"
          fill="black"
          />
          <path d="M9 9L15 15"
            stroke="black"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
          <path d="M9 15L15 9"
            stroke="black"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="2"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-ticket"
          id="ticket"
          viewBox="0 0 24 24"
        >
          <title id="icon-title-ticket">Ticket</title>
          <path d="M8.418 21.588
            c-.103 0-.214-.008-.325-.034
            a1.579 1.579 0 0 1-.643-.266 1.619 1.619 0 0 1-.48-.514 1.729 1.729 0 0 1-.232-.669
            L4.321 6.425
            a1.515 1.515 0 0 1 0-.65
            c.043-.24.137-.464.274-.66
            a1.693 1.693 0 0 1 1.183-.695
            l1.663-.292
            c.292-.051.609-.025.891.069.283.086.55.266.746.489
            l.077.094
            c.223.334.54.6.909.754.368.163.78.206 1.174.129.412-.077.78-.257 1.08-.532.3-.274.506-.625.609-1.028
            L12.96 4
            c.111-.283.291-.532.531-.72
            a1.85 1.85 0 0 1 .815-.369
            l1.688-.3
            c.223-.051.446-.051.678-.008.23.043.454.137.642.274.197.137.36.317.48.514.12.206.197.429.223.669
            l2.417 13.68
            a1.649 1.649 0 0 1-.265 1.303 1.72 1.72 0 0 1-.515.48 1.67 1.67 0 0 1-.668.223
            l-1.663.291
            a1.853 1.853 0 0 1-.892-.069 1.844 1.844 0 0 1-.745-.497
            l-.077-.103
            a2.05 2.05 0 0 0-.909-.754 2.039 2.039 0 0 0-1.174-.12
            c-.412.077-.78.257-1.08.54-.3.274-.506.626-.609 1.02
            l-.034.103
            a1.704 1.704 0 0 1-.531.72 1.85 1.85 0 0 1-.815.369
            l-1.714.3
            a.968.968 0 0 1-.326.042
            z
            M7.793 5.826
            l-1.766.282 2.417 13.74 1.731-.291
            a4.117 4.117 0 0 1 1.123-1.791 3.85 3.85 0 0 1 1.929-.96 3.817 3.817 0 0 1 2.16.222
            c.651.275 1.2.72 1.603 1.295
            l1.765-.283
            L16.338 4.3
            l-.026.008.01-.017-1.715.3
            a4.07 4.07 0 0 1-1.123 1.792 3.78 3.78 0 0 1-1.929.96 3.668 3.668 0 0 1-2.16-.223 3.755 3.755 0 0 1-1.602-1.294
            z"
          fill="#1A1A1A"
          />
          <path d="M11.161 16.017
            a.847.847 0 0 1-.84-.711.861.861 0 0 1 .694-.995
            l3.429-.608
            a.857.857 0 1 1 .3 1.688
            L11.315 16
            c-.051.017-.102.017-.154.017
            z
            M10.998 13.986
            l-.746-1.75-.985-1.542 1.363-1.08 1.054-1.509 1.508 1.055 1.646.557-.403 1.791-.103 1.895-1.723.017-1.611.566
            z
            m.549-2.906
            l.257.428.137.326.377-.128
            h.394
            l.043-.498.077-.351-.514-.223-.214-.146-.309.386-.248.206
            z"
          />
        </symbol>

        <symbol fill="none"
          id="favorite"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12 4.00005
            L14.1 9.60005
            L20 9.80005
            L15.3 13.5001
            L16.9 19.2001
            L12 15.9001
            L7.10002 19.2001
            L8.70002 13.5001
            L4.00002 9.80005
            L9.90002 9.60005
            L12 4.00005
            Z
            M12 2.00005
            C11.588 1.99461 11.1843 2.11657 10.8442 2.34926
            C10.5041 2.58196 10.2442 2.91402 10.1 3.30005
            L8.52002 7.60005
            L3.92002 7.80005
            C3.50891 7.80722 3.11121 7.94756 2.78664 8.2
            C2.46208 8.45243 2.22816 8.80335 2.12002 9.20005
            C1.9772 9.59256 1.96843 10.0213 2.09507 10.4194
            C2.22172 10.8174 2.47665 11.1622 2.82002 11.4001
            L6.42002 14.3001
            L5.22002 18.7001
            C5.12257 19.0956 5.13638 19.5105 5.25991 19.8987
            C5.38344 20.287 5.61189 20.6335 5.92002 20.9001
            C6.25519 21.1801 6.68387 21.323 7.12002 21.3001
            C7.50803 21.3089 7.89023 21.2047 8.22002 21.0001
            L12 18.4001
            L15.8 21.0001
            C16.1298 21.2047 16.512 21.3089 16.9 21.3001
            C17.3328 21.3001 17.7538 21.1597 18.1 20.9001
            C18.4421 20.6611 18.696 20.3162 18.8225 19.9186
            C18.949 19.5209 18.9411 19.0927 18.8 18.7001
            L17.6 14.3001
            L21.2 11.4001
            C21.53 11.1536 21.7758 10.8113 21.9039 10.4199
            C22.032 10.0285 22.0362 9.60712 21.9159 9.21327
            C21.7955 8.81942 21.5565 8.47232 21.2315 8.21938
            C20.9065 7.96644 20.5114 7.82 20.1 7.80005
            L15.5 7.60005
            L13.9 3.30005
            C13.7499 2.91806 13.4885 2.58993 13.1497 2.35816
            C12.811 2.12638 12.4105 2.00163 12 2.00005
            Z"
          fill="#DD0000"
          />
        </symbol>

        <symbol fill="none"
          id="favorite_active"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M12.9 3.19001
            L14.9 7.19001
            C14.9711 7.33558 15.0765 7.4617 15.2072 7.55751
            C15.3378 7.65332 15.4898 7.71595 15.65 7.74001
            L20.11 8.39001
            C20.2931 8.41827 20.4648 8.49686 20.6059 8.61702
            C20.747 8.73718 20.8519 8.89418 20.909 9.0705
            C20.966 9.24681 20.9729 9.43551 20.929 9.61554
            C20.885 9.79556 20.7919 9.95983 20.66 10.09
            L17.44 13.23
            C17.3227 13.3434 17.235 13.4839 17.1844 13.639
            C17.1339 13.7941 17.1221 13.9593 17.15 14.12
            L17.91 18.56
            C17.9299 18.7396 17.9008 18.9211 17.8257 19.0855
            C17.7507 19.2498 17.6325 19.3907 17.4838 19.4933
            C17.3351 19.5958 17.1614 19.6562 16.9811 19.668
            C16.8008 19.6797 16.6208 19.6424 16.46 19.56
            L12.46 17.47
            C12.3153 17.393 12.1539 17.3527 11.99 17.3527
            C11.8261 17.3527 11.6647 17.393 11.52 17.47
            L7.52 19.56
            C7.35924 19.6424 7.17915 19.6797 6.99889 19.668
            C6.81862 19.6562 6.64491 19.5958 6.49619 19.4933
            C6.34748 19.3907 6.22933 19.2498 6.15429 19.0855
            C6.07925 18.9211 6.05012 18.7396 6.07 18.56
            L6.83 14.12
            C6.85794 13.9593 6.84611 13.7941 6.79557 13.639
            C6.74502 13.4839 6.65728 13.3434 6.54 13.23
            L3.35 10.13
            C3.21811 9.99983 3.12499 9.83556 3.08103 9.65554
            C3.03707 9.47551 3.044 9.28681 3.10105 9.1105
            C3.15809 8.93418 3.263 8.77718 3.40408 8.65702
            C3.54516 8.53686 3.71685 8.45827 3.9 8.43001
            L8.36 7.78001
            C8.52022 7.75595 8.67219 7.69332 8.80283 7.59751
            C8.93348 7.5017 9.03889 7.37558 9.11 7.23001
            L11.11 3.23001
            C11.1892 3.06168 11.3137 2.91875 11.4696 2.81731
            C11.6255 2.71587 11.8066 2.65992 11.9926 2.65577
            C12.1786 2.65161 12.362 2.69941 12.5223 2.79379
            C12.6826 2.88816 12.8134 3.02538 12.9 3.19001
            Z"
          fill="currentColor"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-watchlist"
          id="watchlist"
          viewBox="0 0 20 17"
        >
          <title id="icon-title-watchlist">Add to Watch List</title>
          <path d="M4.29937 1.24817
            C6.93043 0.326179 9.12298 2.17016 10 3.55314
            C10.877 2.17016 13.0696 0.326179 15.7006 1.24817
            C16.5776 1.5555 18.0686 2.26236 18.7702 4.47513
            C19.5011 6.78011 18.3317 8.77775 17.4547 10.0071
            C16.5777 11.2364 13.5081 14.156 10 16
            C6.49192 14.156 3.42235 11.2364 2.54533 10.0071
            C1.66831 8.77775 0.498947 6.78011 1.2298 4.47513
            C1.93141 2.26236 3.42235 1.5555 4.29937 1.24817
            Z"
          fill="none"
          stroke="currentColor"
          strokeLinejoin="round"
          strokeWidth="2"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-watchlist-active"
          id="watchlist-active"
          viewBox="0 0 20 17"
        >
          <title id="icon-title-watchlist-active">Added to Watch List</title>
          <path d="M4.29937 1.24817
            C6.93043 0.326179 9.12298 2.17016 10 3.55314
            C10.877 2.17016 13.0696 0.326179 15.7006 1.24817
            C16.5776 1.5555 18.0686 2.26236 18.7702 4.47513
            C19.5011 6.78011 18.3317 8.77775 17.4547 10.0071
            C16.5777 11.2364 13.5081 14.156 10 16
            C6.49192 14.156 3.42235 11.2364 2.54533 10.0071
            C1.66831 8.77775 0.498947 6.78011 1.2298 4.47513
            C1.93141 2.26236 3.42235 1.5555 4.29937 1.24817
            Z"
          fill="currentColor"
          strokeLinejoin="round"
          strokeWidth="2"
          />
        </symbol>

        <symbol aria-labelledby="icon-title-watchlist"
          id="watchlistaccountmenu"
          viewBox="0 0 20 17"
        >
          <title id="icon-title-watchlist">Watch List</title>
          <path d="M4.29937 1.24817
            C6.93043 0.326179 9.12298 2.17016 10 3.55314
            C10.877 2.17016 13.0696 0.326179 15.7006 1.24817
            C16.5776 1.5555 18.0686 2.26236 18.7702 4.47513
            C19.5011 6.78011 18.3317 8.77775 17.4547 10.0071
            C16.5777 11.2364 13.5081 14.156 10 16
            C6.49192 14.156 3.42235 11.2364 2.54533 10.0071
            C1.66831 8.77775 0.498947 6.78011 1.2298 4.47513
            C1.93141 2.26236 3.42235 1.5555 4.29937 1.24817
            Z"
          fill="none"
          strokeLinejoin="round"
          strokeWidth="2"
          />
        </symbol>

        <symbol id="cinemarkcash"
          viewBox="0 0 21 19"
        >
          <path d="M10.2738 7.13855
            L10.2782 7.13736
            C10.62 7.04497 10.9765 7.03015 11.3218 7.09182
            L11.2391 7.61375
            C11.1201 7.59106 10.9985 7.58014 10.8762 7.5815
            C10.5071 7.58559 10.1479 7.70119 9.84571 7.91311
            C9.54353 8.12503 9.31249 8.42338 9.18293 8.76897
            C9.05552 9.10881 9.03209 9.47873 9.11539 9.8317
            C9.15612 10.0573 9.24287 10.2721 9.3703 10.4628
            C9.5012 10.6587 9.67208 10.8247 9.8717 10.9498
            C10.0713 11.075 10.2952 11.1565 10.5285 11.189
            C10.7599 11.2212 10.9955 11.2045 11.2201 11.14
            L13.8716 10.4295
            L14.0217 10.9897
            L11.491 11.6678
            L11.4893 11.6683
            C10.8841 11.8327 10.2384 11.7506 9.69364 11.4399
            C9.14989 11.1297 8.75097 10.6171 8.58389 10.0139
            C8.5065 9.715 8.48851 9.40382 8.53095 9.09798
            C8.57354 8.79099 8.67619 8.4954 8.83303 8.22808
            C8.98987 7.96077 9.19782 7.72696 9.44502 7.54001
            C9.69222 7.35307 9.97382 7.21664 10.2738 7.13855
            Z"
          />
          <path clipRule="evenodd"
            d="M10.5211 3.12211
            C15.0934 0.62817 18.7983 0.616637 20.2747 1.03848
            C20.704 1.16113 21 1.55352 21 2
            V13.0489
            C21 13.3333 20.8789 13.6043 20.6669 13.794
            C20.455 13.9837 20.1723 14.0742 19.8896 14.0427
            C18.5494 13.8938 14.8672 14.0444 11.4856 15.923
            C7.6436 18.0575 2.85036 18.2212 0.909464 18.0448
            C0.394385 17.9979 0 17.5661 0 17.0489
            V6
            C0 5.69668 0.13767 5.40975 0.374273 5.21996
            C0.610875 5.03016 0.920833 4.95801 1.21693 5.02381
            C2.48644 5.30593 6.33861 5.40349 10.5211 3.12211
            Z
            M19 2.84923
            C17.6341 2.74959 14.9069 3.00804 11.4789 4.8779
            C7.71717 6.92972 4.13444 7.28626 2 7.14002
            V16.0965
            C4.05988 16.1245 7.64554 15.7685 10.5144 14.1747
            C13.65 12.4327 16.9875 11.9979 19 12.0002
            V2.84923
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol id="trashcan"
          viewBox="0 0 16 16"
        >
          <path d="M0.870668 4.06051
            H1.96388
            V13.4309
            C1.96388 13.769 2.03059 14.1037 2.16019 14.4159
            C2.28978 14.7281 2.47971 15.0116 2.7191 15.2503
            C2.95849 15.489 3.24262 15.678 3.55521 15.8067
            C3.86781 15.9353 4.20272 16.001 4.54075 16
            H10.7096
            C11.0476 16.001 11.3825 15.9353 11.6951 15.8067
            C12.0077 15.678 12.2919 15.489 12.5313 15.2503
            C12.7706 15.0116 12.9606 14.7281 13.0902 14.4159
            C13.2198 14.1037 13.2865 13.769 13.2865 13.4309
            V4.06051
            H14.3797
            C14.4988 4.07191 14.6191 4.05828 14.7326 4.0205
            C14.8462 3.98271 14.9506 3.92161 15.0392 3.8411
            C15.1278 3.76059 15.1986 3.66246 15.247 3.553
            C15.2954 3.44354 15.3204 3.32516 15.3204 3.20546
            C15.3204 3.08577 15.2954 2.96739 15.247 2.85793
            C15.1986 2.74847 15.1278 2.65033 15.0392 2.56983
            C14.9506 2.48932 14.8462 2.42821 14.7326 2.39043
            C14.6191 2.35264 14.4988 2.33901 14.3797 2.35041
            H10.5534
            V1.71791
            C10.5545 1.49268 10.511 1.26947 10.4255 1.06108
            C10.34 0.852703 10.2142 0.66326 10.0553 0.503635
            C9.89642 0.344009 9.70756 0.217345 9.49957 0.130917
            C9.29158 0.0444882 9.06856 -2.348e-06 8.84333 0
            H6.39921
            C6.17398 -2.348e-06 5.95097 0.0444882 5.74298 0.130917
            C5.53499 0.217345 5.34612 0.344009 5.18722 0.503635
            C5.02832 0.66326 4.90252 0.852703 4.81704 1.06108
            C4.73156 1.26947 4.68808 1.49268 4.68911 1.71791
            V2.31918
            H0.870668
            C0.639752 2.31918 0.418295 2.41091 0.255013 2.57419
            C0.0917309 2.73747 0 2.95893 0 3.18985
            C0 3.42076 0.0917309 3.64222 0.255013 3.8055
            C0.418295 3.96878 0.639752 4.06051 0.870668 4.06051
            Z
            M11.5686 13.4309
            C11.549 13.6449 11.45 13.8439 11.291 13.9884
            C11.1319 14.133 10.9245 14.2127 10.7096 14.2118
            H4.54075
            C4.31294 14.2118 4.09446 14.1213 3.93338 13.9602
            C3.77229 13.7991 3.68179 13.5807 3.68179 13.3528
            V4.06051
            H11.5686
            V13.4309
            Z
            M6.42264 1.71791
            H8.85114
            V2.31918
            H6.39921
            L6.42264 1.71791
            Z"
          />
          <path d="M9.23377 13.1264
            C9.46157 13.1264 9.68005 13.0359 9.84114 12.8748
            C10.0022 12.7137 10.0927 12.4952 10.0927 12.2674
            V5.85651
            C10.0927 5.74371 10.0705 5.63202 10.0273 5.5278
            C9.98417 5.42359 9.9209 5.3289 9.84114 5.24914
            C9.76138 5.16938 9.66669 5.10611 9.56247 5.06294
            C9.45826 5.01977 9.34657 4.99756 9.23377 4.99756
            C9.12097 4.99756 9.00927 5.01977 8.90506 5.06294
            C8.80084 5.10611 8.70615 5.16938 8.62639 5.24914
            C8.54663 5.3289 8.48336 5.42359 8.44019 5.5278
            C8.39703 5.63202 8.37481 5.74371 8.37481 5.85651
            V12.2674
            C8.37481 12.4952 8.46531 12.7137 8.62639 12.8748
            C8.78748 13.0359 9.00596 13.1264 9.23377 13.1264
            Z"
          />
          <path d="M6.01659 13.1264
            C6.2444 13.1264 6.46288 13.0359 6.62396 12.8748
            C6.78505 12.7137 6.87554 12.4952 6.87554 12.2674
            V5.85651
            C6.87554 5.74371 6.85333 5.63202 6.81016 5.5278
            C6.76699 5.42359 6.70372 5.3289 6.62396 5.24914
            C6.5442 5.16938 6.44951 5.10611 6.3453 5.06294
            C6.24108 5.01977 6.12939 4.99756 6.01659 4.99756
            C5.90379 4.99756 5.79209 5.01977 5.68788 5.06294
            C5.58367 5.10611 5.48898 5.16938 5.40922 5.24914
            C5.32945 5.3289 5.26618 5.42359 5.22302 5.5278
            C5.17985 5.63202 5.15763 5.74371 5.15763 5.85651
            V12.2674
            C5.15763 12.4952 5.24813 12.7137 5.40922 12.8748
            C5.5703 13.0359 5.78878 13.1264 6.01659 13.1264
            Z"
          />
        </symbol>

        <symbol fill="none"
          id="pickup-counter"
          viewBox="0 0 62 56"
          xmlns="http://www.w3.org/2000/svg"
        >

          <g clipPath="url(#clip0_12296_12820)">
            <path d="M40.0507 21.117
            H44.9256
            V17.2549
            H40.0507
            C36.8833 17.2549 34.2974 19.8462 34.2974 23.048
            V37.7363
            C34.2974 39.8293 35.9429 41.4987 37.9968 41.5859
            V52.1381
            C37.9968 54.2685 39.7043 56.0002 41.8324 56.0002
            H44.9256
            V52.1381
            H41.8324
            V37.8734
            L38.1329 37.7363
            V23.048
            C38.1329 21.9766 38.999 21.117 40.0507 21.117
            Z"
            fill="currentColor"
            />

            <path d="M44.9256 15.1489
            C41.0158 15.1489 37.8113 12.1091 37.5391 8.24703
            C37.502 8.0477 37.502 7.86083 37.502 7.66149
            C37.502 7.41233 37.5267 7.13825 37.5391 6.88908
            C37.9226 3.12668 41.0653 0.186523 44.9256 0.186523
            V3.72468
            V4.04859
            C42.946 4.04859 41.3375 5.66817 41.3375 7.66149
            C41.3375 8.58341 41.684 9.45549 42.2778 10.0909
            C42.3521 10.1905 42.4511 10.2902 42.55 10.3649
            C42.6614 10.4646 42.7851 10.5643 42.9089 10.639
            C43.0821 10.7761 43.2677 10.8757 43.4656 10.9505
            C43.9111 11.1623 44.406 11.2744 44.9256 11.2744
            V14.9621
            V15.1489
            Z"
            fill="currentColor"
            />

            <path d="M51.706 23.0607
            V37.749
            L48.0065 37.886
            V52.1508
            H44.9133
            V56.0128
            H48.0065
            C50.1346 56.0128 51.8421 54.2687 51.8421 52.1508
            V41.5986
            C53.896 41.5239 55.5415 39.842 55.5415 37.749
            V23.0607
            C55.5415 19.8589 52.9556 17.2676 49.7882 17.2676
            H44.9133
            V21.1296
            H49.7882
            C50.8399 21.1296 51.706 21.9768 51.706 23.0607
            Z"
            fill="currentColor"
            />

            <path d="M44.9133 14.9747
            V11.2871
            C45.433 11.2871 45.9279 11.175 46.3733 10.9632
            C46.5713 10.8884 46.7569 10.7888 46.9301 10.6517
            C47.0662 10.577 47.1776 10.4773 47.2889 10.3776
            C47.3879 10.3029 47.4869 10.2032 47.5611 10.1036
            C48.155 9.46818 48.5014 8.5961 48.5014 7.6742
            C48.5014 5.68086 46.893 4.06129 44.9133 4.06129
            V3.73737
            V0.199219
            C48.7736 0.199219 51.9163 3.13937 52.2999 6.90178
            C52.3246 7.15094 52.337 7.42502 52.337 7.6742
            C52.337 7.87352 52.337 8.0604 52.2999 8.25973
            C52.0277 12.1218 48.8231 15.1616 44.9133 15.1616
            V14.9747
            Z"
            fill="currentColor"
            />

            <path d="M10.0714 30.934
            V23.2472
            C10.0714 22.1633 10.9375 21.3162 11.9892 21.3162
            H16.8641
            V17.4541
            H11.9892
            C8.82175 17.4541 6.23584 20.0454 6.23584 23.2472
            V30.934"
            fill="currentColor"
            />

            <path d="M16.8641 15.3484
            C12.9543 15.3484 9.74975 12.3086 9.47755 8.44649
            C9.44043 8.25962 9.44043 8.06028 9.44043 7.87341
            C9.44043 7.62424 9.46517 7.35016 9.47755 7.101
            C9.8611 3.33859 13.0038 0.398438 16.8641 0.398438
            V3.93659
            V4.26051
            C14.8845 4.26051 13.276 5.88008 13.276 7.87341
            C13.276 8.79532 13.6224 9.6674 14.2163 10.3028
            C14.2906 10.4024 14.3895 10.5021 14.4885 10.5769
            C14.5999 10.6641 14.7112 10.7637 14.8473 10.8385
            C15.0206 10.9755 15.2061 11.0752 15.4041 11.1499
            C15.8495 11.3617 16.3444 11.4739 16.8641 11.4739
            V15.1615
            V15.3484
            Z"
            fill="currentColor"
            />

            <path d="M27.48 30.9093
            V23.2599
            C27.48 20.0581 24.8941 17.4668 21.7267 17.4668
            H16.8518
            V21.3289
            H21.7267
            C22.7784 21.3289 23.6445 22.176 23.6445 23.2599
            V30.9342"
            fill="currentColor"
            />

            <path d="M16.8518 15.174
            V11.4863
            C17.3715 11.4863 17.8664 11.3742 18.3118 11.1624
            C18.5098 11.0876 18.6954 10.988 18.8686 10.8509
            C19.0047 10.7762 19.116 10.6765 19.2274 10.5769
            C19.3264 10.5021 19.4253 10.4024 19.4996 10.3028
            C20.0935 9.6674 20.4399 8.79532 20.4399 7.87341
            C20.4399 5.88008 18.8315 4.26051 16.8518 4.26051
            V3.92413
            V0.398438
            C20.7121 0.398438 23.8548 3.33859 24.2384 7.101
            C24.2631 7.35016 24.2755 7.62424 24.2755 7.87341
            C24.2755 8.07274 24.2755 8.25962 24.2384 8.45895
            C23.9662 12.321 20.7616 15.3608 16.8518 15.3608
            V15.174
            Z"
            fill="currentColor"
            />

            <path d="M1.2373 29.6885H35.745"
              stroke="currentColor"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />

            <path d="M54.5144 29.6885H60.7627"
              stroke="currentColor"
              strokeLinecap="round"
              strokeMiterlimit="10"
              strokeWidth="3"
            />
          </g>

          <defs>
            <clipPath id="clip0_12296_12820">
              <rect fill="white"
                height="56"
                width="62"
              />
            </clipPath>
          </defs>

        </symbol>

        <symbol fill="none"
          id="deliver-to-seat"
          viewBox="0 0 65 52"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M28.3943 49.5113
            H9.11035
            V20.443
            C9.11035 19.195 10.1206 18.1738 11.3553 18.1738
            H26.1606
            C27.3953 18.1738 28.4055 19.195 28.4055 20.443
            V49.5113
            H28.3943
            Z"
          stroke="currentColor"
          strokeMiterlimit="10"
          strokeWidth="3"
          />

          <path clipRule="evenodd"
            d="M3.74493 35.3428
            C3.3538 35.3428 3 35.6771 3 36.112
            V48.0115
            H7.6103
            V36.112
            C7.6103 35.6771 7.2565 35.3428 6.86538 35.3428
            H3.74493
            Z
            M0 36.112
            C0 34.0507 1.66663 32.3428 3.74493 32.3428
            H6.86538
            C8.94368 32.3428 10.6103 34.0507 10.6103 36.112
            V51.0115
            H0
            V36.112
            Z"
            fill="currentColor"
            fillRule="evenodd"
          />

          <path clipRule="evenodd"
            d="M31.3016 35.3428
            C30.9104 35.3428 30.5566 35.6771 30.5566 36.112
            V48.0115
            H35.1669
            V36.112
            C35.1669 35.6771 34.8131 35.3428 34.422 35.3428
            H31.3016
            Z
            M27.5566 36.112
            C27.5566 34.0507 29.2233 32.3428 31.3016 32.3428
            H34.422
            C36.5003 32.3428 38.1669 34.0507 38.1669 36.112
            V51.0115
            H27.5566
            V36.112
            Z"
            fill="currentColor"
            fillRule="evenodd"
          />

          <path d="M10.9287 39.8223H26.5759"
            stroke="currentColor"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />

          <path d="M50.1721 19.2311
            H54.5946
            V15.7139
            H50.1721
            C47.2986 15.7139 44.9526 18.0738 44.9526 20.9897
            V34.3666
            C44.9526 36.2727 46.4455 37.7931 48.3088 37.8725
            V47.4825
            C48.3088 49.4226 49.8578 50.9997 51.7884 50.9997
            H54.5946
            V47.4825
            H51.7884
            V34.4914
            L48.4323 34.3666
            V20.9897
            C48.4323 20.014 49.2068 19.2311 50.1721 19.2311
            Z"
          fill="currentColor"
          />

          <path d="M54.5946 13.7964
            C51.0477 13.7964 48.1405 11.028 47.8935 7.51074
            C47.8599 7.32921 47.8599 7.15902 47.8599 6.97749
            C47.8599 6.75057 47.8823 6.50096 47.8935 6.27404
            C48.2415 2.84756 51.0926 0.169922 54.5946 0.169922
            V3.39217
            V3.68716
            C52.7987 3.68716 51.3395 5.16214 51.3395 6.97749
            C51.3395 7.81709 51.6538 8.6113 52.1926 9.18994
            C52.2599 9.28071 52.3497 9.37148 52.4395 9.43955
            C52.5405 9.53032 52.6528 9.62109 52.765 9.68917
            C52.9222 9.81397 53.0905 9.90474 53.2701 9.97281
            C53.6742 10.1657 54.1232 10.2678 54.5946 10.2678
            V13.6262
            V13.7964
            Z"
          fill="currentColor"
          />

          <path d="M60.7344 21.0014
            V34.3783
            L57.3782 34.5031
            V47.4942
            H54.572
            V51.0115
            H57.3782
            C59.3088 51.0115 60.8578 49.423 60.8578 47.4942
            V37.8842
            C62.7211 37.8161 64.214 36.2844 64.214 34.3783
            V21.0014
            C64.214 18.0855 61.868 15.7256 58.9945 15.7256
            H54.572
            V19.2428
            H58.9945
            C59.9599 19.2428 60.7344 20.0144 60.7344 21.0014
            Z"
          fill="currentColor"
          />

          <path d="M54.572 13.6379
            V10.2795
            C55.0435 10.2795 55.4924 10.1774 55.8965 9.98453
            C56.0761 9.91646 56.2445 9.82569 56.4016 9.70089
            C56.5251 9.63281 56.6261 9.54204 56.7272 9.45127
            C56.8169 9.3832 56.9067 9.29243 56.9741 9.20166
            C57.5129 8.62302 57.8272 7.8288 57.8272 6.98921
            C57.8272 5.17385 56.368 3.69888 54.572 3.69888
            V3.40389
            V0.181641
            C58.0741 0.181641 60.9252 2.85928 61.2731 6.28576
            C61.2956 6.51268 61.3068 6.76229 61.3068 6.98921
            C61.3068 7.17074 61.3068 7.34093 61.2731 7.52246
            C61.0262 11.0397 58.119 13.8081 54.572 13.8081
            V13.6379
            Z"
          fill="currentColor"
          />

          <rect fill="currentColor"
            height="7.65"
            width="7.54839"
            x="41.7153"
            y="21.6748"
          />

          <path d="M34.167 25.2539H45.0549"
            stroke="currentColor"
            strokeLinecap="round"
            strokeMiterlimit="10"
            strokeWidth="3"
          />

          <path d="M41.7774 24.7773H38.0059L37.209 16.96H42.5295L41.7774 24.7773Z"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth="3"
          />

          <path d="M40.2395 15.8588V12.75"
            stroke="currentColor"
            strokeMiterlimit="10"
            strokeWidth="3"
          />

        </symbol>

        <symbol fill="none"
          id="clear"
          viewBox="0 0 16 16"
        >
          <path d="M10.6666 5.33374L5.33358 10.6668"
            stroke="#999999"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <path d="M10.6674 10.6671L5.33437 5.33401"
            stroke="#999999"
            strokeLinecap="round"
            strokeWidth="1.5"
          />
          <circle cx="8"
            cy="8"
            r="7.25"
            stroke="#999999"
            strokeWidth="1.5"
          />
        </symbol>

        <symbol id="notification"
          viewBox="0 0 24 24"
        >
          <path clipRule="evenodd"
            d="M13 2
            C13 1.44772 12.5523 1 12 1
            C11.4477 1 11 1.44772 11 2
            V3.07177
            C9.51321 3.28635 8.12499 3.97552 7.05025 5.05025
            C5.7375 6.36301 5 8.14348 5 10
            V15.6972
            L3.16795 18.4453
            C2.96338 18.7522 2.94431 19.1467 3.11833 19.4719
            C3.29235 19.797 3.63121 20 4 20
            H9
            C9 20.7957 9.31607 21.5587 9.87868 22.1213
            C10.4413 22.6839 11.2043 23 12 23
            C12.7957 23 13.5587 22.6839 14.1213 22.1213
            C14.6839 21.5587 15 20.7957 15 20
            H20
            C20.3688 20 20.7077 19.797 20.8817 19.4719
            C21.0557 19.1467 21.0366 18.7522 20.8321 18.4453
            L19 15.6972
            V10
            C19 8.14349 18.2625 6.36301 16.9497 5.05025
            C15.875 3.97552 14.4868 3.28635 13 3.07177
            V2
            Z
            M12 5
            C10.6739 5 9.40215 5.52678 8.46447 6.46447
            C7.52679 7.40215 7 8.67392 7 10
            V16
            C7 16.1974 6.94156 16.3904 6.83205 16.5547
            L5.86852 18
            H18.1315
            L17.168 16.5547
            C17.0584 16.3904 17 16.1974 17 16
            V10
            C17 8.67392 16.4732 7.40215 15.5355 6.46447
            C14.5979 5.52678 13.3261 5 12 5
            Z
            M11.2929 20.7071
            C11.1054 20.5196 11 20.2652 11 20
            H13
            C13 20.2652 12.8946 20.5196 12.7071 20.7071
            C12.5196 20.8946 12.2652 21 12 21
            C11.7348 21 11.4804 20.8946 11.2929 20.7071
            Z"
            fill="black"
            fillRule="evenodd"
          />
        </symbol>

        <symbol id="ticket02"
          viewBox="0 0 16 20"
        >
          <path clipRule="evenodd"
            d="M12 0
            H14
            C14.5304 0 15.0391 0.210713 15.4142 0.585786
            C15.7893 0.960861 16 1.46957 16 2
            V18
            C16 18.5304 15.7893 19.0391 15.4142 19.4142
            C15.0391 19.7893 14.5304 20 14 20
            H11.9859
            L11.9719 19.9996
            C11.6149 19.9896 11.2671 19.8841 10.9646 19.6942
            C10.6621 19.5043 10.416 19.2368 10.2519 18.9196
            L10.2461 18.9084
            L10.2406 18.8971
            C10.0372 18.4785 9.72016 18.1257 9.32572 17.8788
            C8.93127 17.6319 8.47533 17.501 8.01 17.501
            C7.54467 17.501 7.08873 17.6319 6.69428 17.8788
            C6.29984 18.1257 5.98281 18.4785 5.77943 18.8971
            L5.77383 18.9086
            L5.76794 18.92
            C5.60057 19.2431 5.34823 19.5144 5.0381 19.7047
            C4.72797 19.895 4.37179 19.9971 4.00794 20
            L4 20
            L2 20
            C1.46957 20 0.960861 19.7893 0.585787 19.4142
            C0.210714 19.0391 0 18.5304 0 18
            V2
            C0 1.46957 0.210714 0.960859 0.585787 0.585786
            C0.960859 0.210714 1.46957 0 2 0
            H4.01406
            L4.02812 0.000395536
            C4.38514 0.0104401 4.73294 0.115902 5.03541 0.305825
            C5.33788 0.495747 5.58397 0.7632 5.74812 1.0804
            L5.75392 1.09159
            L5.75943 1.10293
            C5.96281 1.52145 6.27984 1.87432 6.67428 2.12119
            C7.06873 2.36806 7.52467 2.49898 7.99 2.49898
            C8.45533 2.49898 8.91127 2.36806 9.30572 2.12119
            C9.70016 1.87432 10.0172 1.52145 10.2206 1.10293
            L10.2262 1.0914
            L10.2321 1.08003
            C10.3994 0.756942 10.6518 0.485632 10.9619 0.295323
            C11.272 0.105014 11.6282 0.00291884 11.9921 3.14713e-05
            L12 0
            Z
            M3.9718 2
            H2
            L2 18
            H3.9918
            C4.35959 17.254 4.92789 16.6249 5.63322 16.1835
            C6.34577 15.7375 7.1694 15.501 8.01 15.501
            C8.8506 15.501 9.67424 15.7375 10.3868 16.1835
            C11.0921 16.6249 11.6604 17.254 12.0282 18
            H14
            V2
            H12.0082
            C11.6404 2.74601 11.0721 3.37508 10.3668 3.81652
            C9.65423 4.26248 8.8306 4.49898 7.99 4.49898
            C7.1494 4.49898 6.32577 4.26248 5.61322 3.81652
            C4.90789 3.37508 4.33959 2.74601 3.9718 2
            Z"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M5 8
            C5 7.44772 5.44772 7 6 7
            H10
            C10.5523 7 11 7.44772 11 8
            C11 8.55229 10.5523 9 10 9
            H6
            C5.44772 9 5 8.55229 5 8
            Z"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M5 12
            C5 11.4477 5.44772 11 6 11
            H10
            C10.5523 11 11 11.4477 11 12
            C11 12.5523 10.5523 13 10 13
            H6
            C5.44772 13 5 12.5523 5 12
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol height="33"
          id="clock"
          viewBox="0 0 32 33"
          width="32"
        >
          <path clipRule="evenodd"
            d="M16.0001 3.77116
            C9.00447 3.77116 3.33341 9.44222 3.33341 16.4378
            C3.33341 23.4334 9.00447 29.1045 16.0001 29.1045
            C22.9957 29.1045 28.6667 23.4334 28.6667 16.4378
            C28.6667 9.44222 22.9957 3.77116 16.0001 3.77116
            Z
            M0.166748 16.4378
            C0.166748 7.69332 7.25557 0.604492 16.0001 0.604492
            C24.7446 0.604492 31.8334 7.69332 31.8334 16.4378
            C31.8334 25.1823 24.7446 32.2712 16.0001 32.2712
            C7.25557 32.2712 0.166748 25.1823 0.166748 16.4378
            Z"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M16.0001 5.75033
            C16.8745 5.75033 17.5834 6.45921 17.5834 7.33366
            V14.8545
            H22.0009
            C22.8754 14.8545 23.5842 15.5634 23.5842 16.4378
            C23.5842 17.3123 22.8754 18.0212 22.0009 18.0212
            H14.4167
            V7.33366
            C14.4167 6.45921 15.1256 5.75033 16.0001 5.75033
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol id="heart"
          viewBox="0 0 20 18"
        >
          <path clipRule="evenodd"
            d="M9.99993 1.9552
            C9.5282 1.46856 8.94587 1.00499 8.27266 0.651119
            C7.08873 0.0288047 5.59359 -0.265011 3.96859 0.30443
            C2.93031 0.668271 1.10952 1.54566 0.276494 4.17288
            C-0.610419 6.97005 0.834295 9.33066 1.73119 10.5878
            C2.23929 11.3 3.29714 12.3992 4.63969 13.5362
            C5.99575 14.6845 7.70053 15.9211 9.53465 16.8852
            C9.82594 17.0383 10.1739 17.0383 10.4652 16.8852
            C12.2993 15.9211 14.0041 14.6846 15.3602 13.5362
            C16.7027 12.3992 17.7606 11.3 18.2687 10.5878
            C19.1656 9.33066 20.6103 6.97005 19.7234 4.17288
            C18.8903 1.54566 17.0695 0.668271 16.0313 0.30443
            C14.4063 -0.265011 12.9111 0.0288046 11.7272 0.651119
            C11.054 1.00499 10.4717 1.46856 9.99993 1.9552
            Z
            M7.3421 2.42145
            C6.55273 2.00653 5.63607 1.83935 4.63001 2.1919
            C3.91425 2.44272 2.75316 2.97905 2.18295 4.77737
            C1.60817 6.59015 2.50217 8.22483 3.35932 9.42629
            C3.72824 9.9434 4.64368 10.9187 5.9322 12.0099
            C7.08843 12.9891 8.49882 14.0221 9.99993 14.8623
            C11.501 14.0221 12.9114 12.9891 14.0677 12.0099
            C15.3562 10.9187 16.2716 9.9434 16.6405 9.42629
            C17.4977 8.22483 18.3917 6.59015 17.8169 4.77737
            C17.2467 2.97905 16.0856 2.44272 15.3698 2.1919
            C14.3638 1.83935 13.4471 2.00653 12.6578 2.42145
            C11.8461 2.84811 11.2023 3.5244 10.8444 4.08868
            C10.661 4.37789 10.3424 4.55314 9.99993 4.55314
            C9.65747 4.55314 9.33883 4.37789 9.15542 4.08868
            C8.79759 3.5244 8.1538 2.84811 7.3421 2.42145
            Z"
            fillRule="evenodd"
          />
        </symbol>

        <symbol fill="none"
          id="arrow_down"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path clipRule="evenodd"
            d="M11.2929 17.7071
            L1.29289 7.70711
            C0.902369 7.31658 0.902369 6.68342 1.29289 6.29289
            C1.68342 5.90237 2.31658 5.90237 2.70711 6.29289
            L12 15.5858
            L21.2929 6.29289
            C21.6834 5.90237 22.3166 5.90237 22.7071 6.29289
            C23.0976 6.68342 23.0976 7.31658 22.7071 7.70711
            L12.7071 17.7071
            C12.3166 18.0976 11.6834 18.0976 11.2929 17.7071
            Z"
            fill="#DD0000"
            fillRule="evenodd"
          />

        </symbol>

        <symbol fill="none"
          id="badge"
          viewBox="0 0 32 32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#aa)"
            stroke="#D00"
          >
            <path d="M15.746 7.447
            a.267.267 0 0 1 .508 0
            l1.033 3.181
            c.036.11.138.185.254.185
            h3.345
            c.258 0 .365.33.156.482
            l-2.706 1.966
            a.267.267 0 0 0-.096.298
            l1.033 3.181
            a.267.267 0 0 1-.41.298
            l-2.706-1.966
            a.267.267 0 0 0-.314 0
            l-2.706 1.966
            a.267.267 0 0 1-.41-.298
            l1.034-3.18
            a.267.267 0 0 0-.097-.299
            l-2.706-1.966
            a.267.267 0 0 1 .156-.482
            h3.345
            a.267.267 0 0 0 .254-.185
            l1.033-3.18
            Z"
            strokeWidth="2"
            />
            <circle cx="16"
              cy="12.667"
              r="10"
              strokeWidth="2.667"
            />
            <path d="M8.667 20v10.666l7.333-4.4 7.334 4.4V20"
              strokeLinejoin="round"
              strokeWidth="2.667"
            />
          </g>
          <defs>
            <clipPath id="aa">
              <path d="M0 0h32v32H0z"
                fill="#fff"
              />
            </clipPath>
          </defs>
        </symbol>


        <symbol fill="none"
          height="32"
          id="moon"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M28.4999 21.3
            C28.4925 21.185 28.4621 21.0727 28.4106 20.9697
            C28.359 20.8666 28.2874 20.7749 28.1999 20.7
            C28.0372 20.5254 27.8205 20.4108 27.5846 20.3745
            C27.3488 20.3382 27.1076 20.3824 26.8999 20.5
            C25.6497 21.0925 24.2835 21.3999 22.8999 21.4
            C21.2403 21.4324 19.6071 20.9807 18.1999 20.1
            C16.7865 19.2865 15.6134 18.1134 14.7999 16.7
            C13.9639 15.2736 13.5157 13.6532 13.4999 12
            C13.5146 10.6931 13.7864 9.40183 14.2999 8.19997
            C14.8468 6.9913 15.6286 5.90352 16.5999 4.99997
            C16.7867 4.84702 16.9175 4.63642 16.9718 4.40117
            C17.0261 4.16593 17.0008 3.91931 16.8999 3.69997
            C16.8178 3.47947 16.6659 3.2918 16.4674 3.16546
            C16.2688 3.03913 16.0345 2.98102 15.7999 2.99997
            C14.0721 3.07839 12.3751 3.48567 10.7999 4.19997
            C9.2722 4.8723 7.88211 5.82162 6.69995 6.99997
            C5.57359 8.24081 4.66117 9.66012 3.99995 11.2
            C3.31433 12.8115 2.97369 14.5488 2.99995 16.3
            C3.01782 18.0891 3.39175 19.8568 4.09995 21.5
            C4.7952 23.075 5.74076 24.5271 6.89995 25.8
            C8.12976 27.0138 9.59244 27.9662 11.1999 28.6
            C13.189 29.4687 15.3621 29.832 17.5256 29.6576
            C19.689 29.4831 21.7758 28.7762 23.5999 27.6
            C25.7343 26.2393 27.4346 24.2961 28.4999 22
            C28.4999 21.7 28.5999 21.5 28.4999 21.3
            Z
            M21.0999 26.4
            C19.6008 27.1165 17.9615 27.4921 16.2999 27.5
            C14.8198 27.5006 13.3556 27.1942 11.9999 26.6
            C10.6735 26.0624 9.47941 25.2436 8.49995 24.2
            C7.50018 23.1837 6.68771 21.9988 6.09995 20.7
            C5.50576 19.3443 5.1993 17.8801 5.19995 16.4
            C5.16147 13.9832 5.93627 11.6235 7.39995 9.69997
            C8.81111 7.7789 10.8135 6.37373 13.0999 5.69997
            C11.9188 7.55169 11.294 9.7036 11.2999 11.9
            C11.2726 13.9774 11.8268 16.021 12.8999 17.8
            C13.9375 19.588 15.4248 21.0733 17.2142 22.1083
            C19.0036 23.1434 21.0328 23.6921 23.0999 23.7
            C23.7375 23.6829 24.3728 23.616 24.9999 23.5
            C23.9035 24.714 22.5782 25.6995 21.0999 26.4
            Z"
          fill="#DD0000"
          />
        </symbol>

        <symbol fill="none"
          height="32"
          id="moon-filled"
          viewBox="0 0 32 32"
          width="32"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M28.4999 21.3 C28.4925 21.185 28.4621 21.0727 28.4106 20.9697 C28.359 20.8666 28.2874 20.7749 28.1999 20.7 C28.0372 20.5254 27.8205
           20.4108 27.5846 20.3745 C27.3488 20.3382 27.1076 20.3824 26.8999 20.5 C25.6497 21.0925 24.2835 21.3999 22.8999 21.4 C21.2403 21.4324 19.6071
           20.9807 18.1999 20.1 C16.7865 19.2865 15.6134 18.1134 14.7999 16.7 C13.9639 15.2736 13.5157 13.6532 13.4999 12 C13.5146 10.6931 13.7864
           9.40183 14.2999 8.19997 C14.8468 6.9913 15.6286 5.90352 16.5999 4.99997 C16.7867 4.84702 16.9175 4.63642 16.9718 4.40117 C17.0261 4.16593
           17.0008 3.91931 16.8999 3.69997 C16.8178 3.47947 16.6659 3.2918 16.4674 3.16546 C16.2688 3.03913 16.0345 2.98102 15.7999 2.99997 C14.0721
           3.07839 12.3751 3.48567 10.7999 4.19997 C9.2722 4.8723 7.88211 5.82162 6.69995 6.99997 C5.57359 8.24081 4.66117 9.66012 3.99995 11.2
           C3.31433 12.8115 2.97369 14.5488 2.99995 16.3 C3.01782 18.0891 3.39175 19.8568 4.09995 21.5 C4.7952 23.075 5.74076 24.5271 6.89995 25.8
           C8.12976 27.0138 9.59244 27.9662 11.1999 28.6 C13.189 29.4687 15.3621 29.832 17.5256 29.6576 C19.689 29.4831 21.7758 28.7762 23.5999 27.6
           C25.7343 26.2393 27.4346 24.2961 28.4999 22 C28.4999 21.7 28.5999 21.5 28.4999 21.3 Z"
          fill="#DD0000"
          />
        </symbol>

        <symbol fill="none"
          id="theater-placeholder"
          viewBox="0 0 113 80"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M104.954 32.443C104.954 28.0999 101.434 24.5791 97.0905 24.5791H86.8743V35.2193H104.954V32.443Z"
            fill="#CCCCCC"
          />
          <path d="M6.78162 32.443C6.78162 28.0999 10.3024 24.5791 14.6455 24.5791H24.8617V35.2193H6.78162V32.443Z"
            fill="#CCCCCC"
          />
          <path d="M84.0685 74.9062H69.4747V55.3994H43.4747V74.9062H28.5441V51.9961H84.0685V74.9062Z"
            fill="#CCCCCC"
          />
          <rect fill="#CCCCCC"
            height="17.8454"
            width="10.0607"
            x="45.5215"
            y="57.0742"
          />
          <rect fill="#CCCCCC"
            height="17.8454"
            width="9.77935"
            x="57.5272"
            y="57.0742"
          />
          <path d="M104.954 41.1279
            V74.9033
            H86.8744
            V52.0059
            H87.3939
            C89.8017 52.0056 91.7533 50.0533 91.7533 47.6455
            V41.6836
            C91.7533 41.4954 91.7403 41.3098 91.7172 41.1279
            H104.954
            Z"
          fill="#CCCCCC"
          />
          <path d="M19.9896 41.1279
            C19.9623 41.3251 19.9476 41.5267 19.9476 41.7314
            V47.6465
            C19.9477 50.0543 21.8992 52.0067 24.307 52.0068
            H24.8617
            V74.8916
            H6.78162
            V41.1279
            H19.9896
            Z"
          fill="#CCCCCC"
          />
          <path d="M23.4656 40.3357
            C23.4656 39.0328 24.5218 37.9766 25.8247 37.9766
            H86.5359
            C87.8388 37.9766 88.8951 39.0328 88.8951 40.3357
            V46.621
            C88.8951 47.9239 87.8388 48.9801 86.5359 48.9801
            H25.8247
            C24.5218 48.9801 23.4656 47.9239 23.4656 46.621
            V40.3357
            Z"
          fill="#CCCCCC"
          />
          <path d="M110.865 76.8906
            C111.724 76.8906 112.42 77.5868 112.42 78.4455
            C112.42 79.3043 111.724 80.0004 110.865 80.0004
            H1.55491
            C0.696155 80.0004 0 79.3043 0 78.4455
            C0 77.5868 0.696155 76.8906 1.55491 76.8906
            H110.865
            Z"
          fill="#CCCCCC"
          />
          <path d="M75.7666 0
            C80.1097 0 83.6309 3.52118 83.6309 7.86426
            V35.2197
            H28.1064
            V7.86426
            C28.1064 3.52122 31.6277 7.82631e-05 35.9707 0
            H75.7666
            Z
            M56.3369 8.19434
            C51.9021 8.19434 48.3066 11.7898 48.3066 16.2246
            C48.3068 20.6593 51.9022 24.2539 56.3369 24.2539
            C60.7716 24.2539 64.367 20.6593 64.3672 16.2246
            C64.3672 11.7898 60.7717 8.19436 56.3369 8.19434
            Z"
          fill="#CCCCCC"
          />
          <g clipPath="url(#clip0_2636_10896)">
            <path d="M58.5196 20.3487
            C59.1635 20.0235 59.7234 19.5484 60.1516 18.9631
            L60.331 18.7355
            L59.0556 17.7863
            L58.8845 18.0044
            C58.2531 18.8551 57.2297 19.3145 56.1825 19.218
            C55.1342 19.1215 54.2103 18.4838 53.7406 17.5314
            C53.2699 16.579 53.3207 15.4484 53.8744 14.5432
            C54.4281 13.638 55.4048 13.0874 56.4572 13.0874
            C57.4153 13.079 58.3195 13.5373 58.8877 14.3177
            L59.0556 14.5442
            L60.3445 13.5814
            L60.164 13.3527
            C59.29 12.1686 57.9172 11.47 56.4572 11.4658
            C53.8993 11.4658 51.8245 13.5583 51.8183 16.1448
            C51.8152 16.7731 51.9417 17.3951 52.1916 17.9698
            C52.4145 18.5331 52.7525 19.0418 53.1838 19.4645
            L53.1859 19.4666
            C54.0496 20.3497 55.2286 20.8448 56.4572 20.8374
            C57.1737 20.8406 57.8798 20.6728 58.5196 20.3476
            V20.3487
            Z"
            fill="#CCCCCC"
            />
          </g>
          <defs>
            <clipPath id="clip0_2636_10896">
              <rect fill="white"
                height="9.43979"
                transform="translate(51.8185 11.4658)"
                width="8.60686"
              />
            </clipPath>
          </defs>
        </symbol>

        <symbol fill="none"
          id="filter"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_767_0)">
            <g clipPath="url(#clip1_767_0)">
              <path d="M9.74 8.39
            C9.74 6.52 8.4 4.95 6.63 4.6
            V2
            H5.11
            V4.6
            C3.34 4.95 2 6.52 2 8.39
            C2 10.26 3.34 11.83 5.11 12.18
            V22
            H6.63
            V12.18
            C8.4 11.83 9.74 10.26 9.74 8.39
            Z
            M5.87 10.6
            C4.65 10.6 3.66 9.61 3.66 8.39
            C3.66 7.17 4.65 6.18 5.87 6.18
            C7.09 6.18 8.08 7.17 8.08 8.39
            C8.08 9.61 7.09 10.6 5.87 10.6
            Z"
              fill="currentColor"
              />
              <path d="M22 8.39
            C22 6.52 20.66 4.95 18.89 4.6
            V2
            H17.37
            V4.6
            C15.6 4.95 14.26 6.52 14.26 8.39
            C14.26 10.26 15.6 11.83 17.37 12.18
            V22
            H18.89
            V12.18
            C20.66 11.83 22 10.26 22 8.39
            Z
            M18.13 10.6
            C16.91 10.6 15.92 9.61 15.92 8.39
            C15.92 7.17 16.91 6.18 18.13 6.18
            C19.35 6.18 20.34 7.17 20.34 8.39
            C20.34 9.61 19.35 10.6 18.13 10.6
            Z"
              fill="currentColor"
              />
              <path d="M12.7599 12.06
            V2
            H11.2399
            V12.06
            C9.46988 12.41 8.12988 13.98 8.12988 15.85
            C8.12988 17.72 9.46988 19.29 11.2399 19.64
            V22
            H12.7599
            V19.65
            C14.5299 19.3 15.8699 17.73 15.8699 15.86
            C15.8699 13.99 14.5299 12.41 12.7599 12.06
            Z
            M11.9999 18.06
            C10.7799 18.06 9.78988 17.07 9.78988 15.85
            C9.78988 14.63 10.7799 13.64 11.9999 13.64
            C13.2199 13.64 14.2099 14.63 14.2099 15.85
            C14.2099 17.07 13.2199 18.06 11.9999 18.06
            Z"
              fill="currentColor"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_767_0">
              <rect fill="white"
                height="24"
                width="24"
              />
            </clipPath>
            <clipPath id="clip1_767_0">
              <rect fill="white"
                height="20"
                transform="translate(2 2)"
                width="20"
              />
            </clipPath>
          </defs>
        </symbol>

        <symbol fill="none"
          id="movie-fan"
          viewBox="0 0 245 70"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3701_21341)">
            <path d="M21.4096 29.0997
            H28.6397
            V69.4315
            H21.2386
            C21.2386 60.2288 21.2956 54.0659 21.4096 50.943
            C21.5236 47.82 21.8437 44.9288 22.3786 42.2783
            L16.398 57.1058
            L10.3605 41.9939
            C10.9305 45.0251 11.2725 47.9949 11.3865 50.9123
            C11.5005 53.8297 11.5575 60.0013 11.5575 69.4315
            H4.20898
            V29.0997
            H11.4435
            L16.398 41.8234
            L21.4096 29.0997
            Z"
            fill="#FAFAFA"
            />
            <path d="M38.3779 64.8607
            C36.5189 61.4316 35.5894 56.2354 35.5894 49.2677
            C35.5894 42.3001 36.5189 37.1039 38.3779 33.6747
            C40.237 30.2456 43.0475 28.5354 46.805 28.5354
            C50.5626 28.5354 53.3731 30.25 55.2321 33.6747
            C57.0912 37.1039 58.0207 42.3001 58.0207 49.2677
            C58.0207 56.2354 57.0912 61.4359 55.2321 64.8607
            C53.3731 68.2898 50.5626 70 46.805 70
            C43.0475 70 40.237 68.2855 38.3779 64.8607
            Z
            M50.0496 49.2677
            C50.0496 40.4455 48.9666 36.0323 46.805 36.0323
            C44.6435 36.0323 43.5035 40.4455 43.5035 49.2677
            C43.5035 58.0899 44.604 62.5032 46.805 62.5032
            C49.0061 62.5032 50.0496 58.0899 50.0496 49.2677
            Z"
            fill="#FAFAFA"
            />
            <path d="M86.5512 29.0997
            L79.8297 69.4315
            H69.5786
            L62.5151 29.0997
            H71.1702
            C72.4593 39.5139 73.3537 46.9583 73.8492 51.4241
            C74.3403 55.8942 74.6472 59.319 74.7612 61.7071
            C74.8752 59.3234 75.1777 55.8942 75.6732 51.4241
            C76.1642 46.954 77.0587 39.5139 78.3478 29.0997
            H86.5469
            H86.5512
            Z"
            fill="#FAFAFA"
            />
            <path d="M100.617 69.4315H92.6455V29.0997H100.617V69.4315Z"
              fill="#FAFAFA"
            />
            <path d="M124.762 29.0997
            V36.3122
            H116.563
            V45.5718
            H123.737
            V52.6182
            H116.563
            V62.2189
            H124.762
            V69.4315
            H108.588
            V29.0997
            H124.762
            Z"
            fill="#FAFAFA"
            />
            <path d="M146.672 69.4577
            H133.51
            V2.87805
            H158.607
            V14.7882
            H146.668
            V30.9192
            H157.949
            V42.5494
            H146.668
            V69.462
            L146.672 69.4577
            Z"
            fill="#FAFAFA"
            />
            <path d="M202.132 69.4577
            H187.843
            L186.059 54.8269
            H177.785
            L176 69.4577
            H162.465
            L173.558 2.87805
            H190.478
            L202.137 69.4577
            H202.132
            Z
            M184.743 43.9534
            C183.112 29.8869 182.174 20.448 181.924 15.6324
            C181.608 21.6334 180.67 31.0723 179.105 43.9534
            H184.743
            Z"
            fill="#FAFAFA"
            />
            <path d="M245 2.87803
            V69.4576
            H233.158
            L220.657 30.9148
            C221.411 35.6036 221.911 40.6205 222.161 45.9654
            C222.411 51.3103 222.538 59.1396 222.538 69.4576
            H210.318
            V2.87803
            H222.161
            L234.661 41.7927
            C233.907 37.1651 233.407 32.1351 233.158 26.694
            C232.908 21.2528 232.78 13.3185 232.78 2.87366
            H245
            V2.87803
            Z"
            fill="#FAFAFA"
            />
            <path d="M37.8915 0
            L40.6888 8.59473
            H49.7517
            L42.4207 13.909
            L45.2224 22.5037
            L37.8915 17.1938
            L30.5605 22.5037
            L33.3578 13.909
            L26.0312 8.59473
            H35.0897
            L37.8915 0
            Z"
            fill="#FAFAFA"
            />
            <path d="M11.8602 0
            L14.6619 8.59473
            H23.7204
            L16.3895 13.909
            L19.1912 22.5037
            L11.8602 17.1938
            L4.52924 22.5037
            L7.33097 13.909
            L0 8.59473
            H9.06287
            L11.8602 0
            Z"
            fill="#FAFAFA"
            />
            <path d="M89.9491 0
            L92.7508 8.59473
            H101.809
            L94.4783 13.909
            L97.28 22.5037
            L89.9491 17.1938
            L82.6181 22.5037
            L85.4198 13.909
            L78.0889 8.59473
            H87.1473
            L89.9491 0
            Z"
            fill="#FAFAFA"
            />
            <path d="M63.9178 0
            L66.7196 8.59473
            H75.778
            L68.4515 13.909
            L71.2488 22.5037
            L63.9178 17.1938
            L56.5912 22.5037
            L59.3886 13.909
            L52.0576 8.59473
            H61.1205
            L63.9178 0
            Z"
            fill="#FAFAFA"
            />
            <path d="M115.98 0
            L118.778 8.59473
            H127.841
            L120.51 13.909
            L123.307 22.5037
            L115.98 17.1938
            L108.649 22.5037
            L111.447 13.909
            L104.12 8.59473
            H113.179
            L115.98 0
            Z"
            fill="#FAFAFA"
            />
          </g>
          <defs>
            <clipPath id="clip0_3701_21341">
              <rect fill="white"
                height="70"
                width="245"
              />
            </clipPath>
          </defs>
        </symbol>

        <symbol fill="none"
          id="movie-club"
          viewBox="0 0 287 70"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_3701_21402)">
            <path d="M144.654 65.7073
            C141.2 63.037 138.545 59.1662 136.691 54.0994
            C134.836 49.0326 133.913 42.9873 133.913 35.9633
            C133.913 28.9394 134.84 22.8941 136.691 17.8273
            C138.541 12.7605 141.195 8.88971 144.654 6.21931
            C148.109 3.54892 152.222 2.20937 156.995 2.20937
            C159.004 2.20937 160.766 2.45727 162.273 2.95743
            V14.2392
            C161.707 13.6782 160.577 13.3998 158.881 13.3998
            C155.11 13.3998 152.192 15.3917 150.117 19.3669
            C148.043 23.3464 147.01 28.8785 147.01 35.9633
            C147.01 43.0481 148.047 48.5846 150.117 52.5598
            C152.192 56.5393 155.11 58.5269 158.881 58.5269
            C160.577 58.5269 161.707 58.2485 162.273 57.6875
            V68.9692
            C160.766 69.465 159.008 69.7173 156.995 69.7173
            C152.222 69.7173 148.104 68.3821 144.654 65.7073
            Z"
            fill="currentColor"
            />
            <path d="M199.964 69.0649H172.641V2.86174H185.835V57.2221H199.969V69.0649H199.964Z"
              fill="currentColor"
            />
            <path d="M212.872 65.429
            C209.857 62.3846 208.35 58.1876 208.35 52.8425
            V2.86174
            H221.446
            V52.8425
            C221.446 54.4604 221.789 55.7347 222.484 56.6654
            C223.174 57.5961 224.114 58.0658 225.31 58.0658
            C226.505 58.0658 227.428 57.6005 228.087 56.6654
            C228.746 55.7347 229.076 54.4604 229.076 52.8425
            V2.86174
            H242.173
            V52.8425
            C242.173 58.192 240.679 62.3846 237.699 65.429
            C234.715 68.4778 230.583 70 225.31 70
            C220.036 70 215.887 68.4778 212.872 65.429
            Z"
            fill="currentColor"
            />
            <path d="M252.541 69.0649
            V2.86174
            H267.237
            C272.951 2.86174 277.381 4.27522 280.523 7.10653
            C283.665 9.93785 285.234 13.9608 285.234 19.1798
            C285.234 22.2895 284.465 25.2252 282.927 27.9913
            C281.389 30.7574 278.985 32.4535 275.719 33.0711
            C279.174 33.941 281.811 35.885 283.635 38.899
            C285.454 41.913 286.368 45.3793 286.368 49.2979
            C286.368 55.5129 284.672 60.3622 281.279 63.8415
            C277.886 67.3252 273.205 69.0649 267.237 69.0649
            H252.541
            Z
            M267.237 29.9006
            C268.872 29.9006 270.16 29.2004 271.1 27.8043
            C272.041 26.4082 272.515 24.4641 272.515 21.9764
            C272.515 19.4886 272.045 17.5489 271.1 16.1485
            C270.155 14.748 268.872 14.0522 267.237 14.0522
            H265.73
            V29.9049
            H267.237
            V29.9006
            Z
            M267.237 57.8745
            C269.057 57.8745 270.489 57.0829 271.527 55.4955
            C272.564 53.9124 273.082 51.7508 273.082 49.0152
            C273.082 46.0926 272.564 43.8266 271.527 42.2087
            C270.489 40.5908 269.061 39.7862 267.237 39.7862
            H265.73
            V57.8745
            H267.237
            Z"
            fill="currentColor"
            />
            <path d="M21.4605 28.935
            H28.7077
            V69.0388
            H21.2891
            C21.2891 59.8881 21.3462 53.7601 21.4605 50.6548
            C21.5747 47.5495 21.8956 44.6747 22.4318 42.0391
            L16.4371 56.7828
            L10.3853 41.7564
            C10.9566 44.7704 11.2994 47.7235 11.4137 50.6244
            C11.528 53.5253 11.5851 59.662 11.5851 69.0388
            H4.21924
            V28.935
            H11.4708
            L16.4371 41.5868
            L21.4605 28.935
            Z"
            fill="currentColor"
            />
            <path d="M38.4685 64.4939
            C36.6051 61.0842 35.6733 55.9174 35.6733 48.9891
            C35.6733 42.0609 36.6051 36.8941 38.4685 33.4843
            C40.3319 30.0746 43.1491 28.374 46.9155 28.374
            C50.682 28.374 53.4991 30.0789 55.3625 33.4843
            C57.226 36.8941 58.1577 42.0609 58.1577 48.9891
            C58.1577 55.9174 57.226 61.0885 55.3625 64.4939
            C53.4991 67.9037 50.682 69.6042 46.9155 69.6042
            C43.1491 69.6042 40.3319 67.8993 38.4685 64.4939
            Z
            M50.1678 48.9891
            C50.1678 40.2168 49.0822 35.8285 46.9155 35.8285
            C44.7488 35.8285 43.6062 40.2168 43.6062 48.9891
            C43.6062 57.7614 44.7093 62.1497 46.9155 62.1497
            C49.1218 62.1497 50.1678 57.7614 50.1678 48.9891
            Z"
            fill="currentColor"
            />
            <path d="M86.7555 28.935
            L80.0181 69.0388
            H69.7428
            L62.6626 28.935
            H71.3382
            C72.6303 39.2904 73.5268 46.6927 74.0234 51.1332
            C74.5157 55.5781 74.8233 58.9835 74.9376 61.3582
            C75.0518 58.9879 75.3551 55.5781 75.8517 51.1332
            C76.344 46.6884 77.2405 39.2904 78.5326 28.935
            H86.7511
            H86.7555
            Z"
            fill="currentColor"
            />
            <path d="M100.854 69.0388H92.8643V28.935H100.854V69.0388Z"
              fill="currentColor"
            />
            <path d="M125.057 28.935
            V36.1068
            H116.839
            V45.314
            H124.029
            V52.3206
            H116.839
            V61.867
            H125.057
            V69.0388
            H108.844
            V28.935
            H125.057
            Z"
            fill="currentColor"
            />
            <path d="M37.981 0
            L40.785 8.54613
            H49.8692
            L42.521 13.8304
            L45.3293 22.3765
            L37.981 17.0966
            L30.6327 22.3765
            L33.4367 13.8304
            L26.0928 8.54613
            H35.1727
            L37.981 0
            Z"
            fill="currentColor"
            />
            <path d="M11.8882 0
            L14.6966 8.54613
            H23.7765
            L16.4282 13.8304
            L19.2365 22.3765
            L11.8882 17.0966
            L4.53994 22.3765
            L7.34829 13.8304
            L0 8.54613
            H9.08428
            L11.8882 0
            Z"
            fill="currentColor"
            />
            <path d="M90.1617 0
            L92.97 8.54613
            H102.05
            L94.7016 13.8304
            L97.51 22.3765
            L90.1617 17.0966
            L82.8134 22.3765
            L85.6217 13.8304
            L78.2734 8.54613
            H87.3533
            L90.1617 0
            Z"
            fill="currentColor"
            />
            <path d="M64.0689 0
            L66.8772 8.54613
            H75.9571
            L68.6132 13.8304
            L71.4172 22.3765
            L64.0689 17.0966
            L56.725 22.3765
            L59.529 13.8304
            L52.1807 8.54613
            H61.2649
            L64.0689 0
            Z"
            fill="currentColor"
            />
            <path d="M116.254 0
            L119.058 8.54613
            H128.142
            L120.794 13.8304
            L123.598 22.3765
            L116.254 17.0966
            L108.906 22.3765
            L111.71 13.8304
            L104.366 8.54613
            H113.446
            L116.254 0
            Z"
            fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_3701_21402">
              <rect fill="white"
                height="70"
                width="286.364"
              />
            </clipPath>
          </defs>
        </symbol>

        <symbol fill="none"
          id="mc-platinum"
          viewBox="0 0 625 70"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M143.993 65.5529
            C140.571 62.8841 137.942 59.0131 136.119 53.9399
            C134.283 48.8799 133.371 42.829 133.371 35.8004
            C133.371 28.7719 134.283 22.7342 136.119 17.661
            C137.955 12.601 140.585 8.72997 143.993 6.04802
            C147.415 3.37929 151.484 2.04492 156.201 2.04492
            C158.196 2.04492 159.926 2.29594 161.419 2.78477
            V14.0674
            C160.864 13.5125 159.741 13.2219 158.063 13.2219
            C154.338 13.2219 151.445 15.2168 149.397 19.1935
            C147.349 23.1702 146.318 28.7058 146.318 35.7872
            C146.318 42.8686 147.349 48.4043 149.397 52.3809
            C151.445 56.3576 154.338 58.3526 158.063 58.3526
            C159.741 58.3526 160.864 58.0751 161.419 57.507
            V68.7897
            C159.926 69.2917 158.182 69.5295 156.201 69.5295
            C151.471 69.5295 147.402 68.1952 143.993 65.5264
            V65.5529
            Z"
          fill="#12100D"
          />
          <path d="M199.213 69.5295H171.64V2.04492H184.948V57.4604H199.213V69.5295Z"
            fill="#12100D"
          />
          <path d="M211.861 64.9627
            C208.858 61.9066 207.356 57.681 207.356 52.2995
            V2.04504
            H220.392
            V52.3128
            C220.392 53.9339 220.737 55.2228 221.428 56.1529
            C222.119 57.0964 223.049 57.5614 224.245 57.5614
            C225.441 57.5614 226.358 57.0964 227.009 56.1529
            C227.66 55.2095 227.992 53.9339 227.992 52.3128
            V2.04504
            H241.028
            V52.3128
            C241.028 57.6943 239.54 61.9066 236.576 64.976
            C233.6 68.0455 229.494 69.5736 224.245 69.5736
            C218.997 69.5736 214.864 68.0455 211.861 64.976
            V64.9627
            Z"
          fill="#12100D"
          />
          <path d="M251.124 69.5162
            V2.04504
            H265.951
            C271.715 2.04504 276.187 3.48604 279.351 6.36804
            C282.516 9.25005 284.105 13.3576 284.105 18.6772
            C284.105 21.842 283.324 24.8452 281.776 27.6598
            C280.227 30.4745 277.803 32.2118 274.503 32.8447
            C277.991 33.7336 280.644 35.7133 282.489 38.7838
            C284.321 41.8544 285.25 45.3828 285.25 49.3826
            C285.25 55.7257 283.54 60.6682 280.119 64.2101
            C276.698 67.7654 271.971 69.5297 265.951 69.5297
            H251.124
            V69.5162
            Z
            M265.951 29.5991
            C267.594 29.5991 268.901 28.8854 269.844 27.4578
            C270.8 26.0303 271.271 24.0506 271.271 21.5187
            C271.271 18.9869 270.8 17.0072 269.844 15.5797
            C268.887 14.1521 267.594 13.4384 265.951 13.4384
            H264.43
            V29.5991
            H265.951
            Z
            M265.951 58.1094
            C267.783 58.1094 269.224 57.3014 270.275 55.6853
            C271.325 54.0692 271.837 51.874 271.837 49.0863
            C271.837 46.11 271.311 43.7937 270.275 42.1506
            C269.224 40.5076 267.783 39.6861 265.951 39.6861
            H264.43
            V58.1229
            H265.951
            V58.1094
            Z"
          fill="#12100D"
          />
          <path d="M21.3664 29.1002
            H28.5817
            V69.4287
            H21.1937
            C21.1937 60.2202 21.2468 54.068 21.3664 50.9321
            C21.486 47.8094 21.805 44.926 22.3365 42.2684
            L16.3703 57.0976
            L10.3509 41.9894
            C10.9223 45.019 11.2544 47.9955 11.374 50.9055
            C11.4936 53.8155 11.5468 59.9943 11.5468 69.4287
            H4.21191
            V29.1002
            H11.4272
            L16.3703 41.8299
            L21.3664 29.1002
            Z"
          fill="#12100D"
          />
          <path d="M38.2948 64.8576
            C36.4345 61.4294 35.5176 56.2338 35.5176 49.2577
            C35.5176 42.2817 36.4478 37.0861 38.2948 33.6579
            C40.1551 30.2296 42.9588 28.5155 46.7059 28.5155
            C50.4531 28.5155 53.2568 30.2296 55.1171 33.6579
            C56.9774 37.0861 57.8943 42.2817 57.8943 49.2577
            C57.8943 56.2338 56.9641 61.4294 55.1171 64.8576
            C53.2568 68.2859 50.4531 70 46.7059 70
            C42.9588 70 40.1551 68.2859 38.2948 64.8576
            Z
            M49.9348 49.271
            C49.9348 40.4479 48.8585 36.0364 46.6926 36.0364
            C44.5267 36.0364 43.3973 40.4479 43.3973 49.271
            C43.3973 58.0941 44.5001 62.5057 46.6926 62.5057
            C48.8851 62.5057 49.9348 58.0941 49.9348 49.271
            Z"
          fill="#12100D"
          />
          <path d="M86.3432 29.1002
            L79.6462 69.4287
            H69.4146
            L62.3721 29.1002
            H71.0091
            C72.2981 39.5178 73.1883 46.959 73.68 51.4237
            C74.1716 55.8884 74.4773 59.3167 74.5836 61.7085
            C74.7031 59.3167 74.9955 55.9017 75.4871 51.4237
            C75.9788 46.959 76.8691 39.5178 78.158 29.1002
            H86.3432
            Z"
          fill="#12100D"
          />
          <path d="M100.375 69.4287H92.416V29.1002H100.375V69.4287Z"
            fill="#12100D"
          />
          <path d="M124.468 29.1003
            V36.3156
            H116.283
            V45.5772
            H123.445
            V52.6197
            H116.283
            V62.2268
            H124.468
            V69.4421
            H108.337
            V29.1136
            H124.468
            V29.1003
            Z"
          fill="#12100D"
          />
          <path d="M37.8037 0
            L40.5941 8.5972
            H49.6431
            L42.3215 13.9123
            L45.112 22.5095
            L37.8037 17.1944
            L30.4954 22.5095
            L33.2858 13.9123
            L25.9775 8.5972
            H35.0133
            L37.8037 0
            Z"
          fill="#12100D"
          />
          <path d="M11.8394 0
            L14.6299 8.5972
            H23.6656
            L16.3573 13.9123
            L19.1477 22.5095
            L11.8394 17.1944
            L4.51784 22.5095
            L7.32157 13.9123
            L0 8.5972
            H9.04898
            L11.8394 0
            Z"
          fill="#12100D"
          />
          <path d="M89.7334 0
            L92.5371 8.5972
            H101.573
            L94.2645 13.9123
            L97.0549 22.5095
            L89.7334 17.1944
            L82.4251 22.5095
            L85.2155 13.9123
            L77.9072 8.5972
            H86.9429
            L89.7334 0
            Z"
          fill="#12100D"
          />
          <path d="M63.7675 0
            L66.558 8.5972
            H75.607
            L68.2854 13.9123
            L71.0891 22.5095
            L63.7675 17.1944
            L56.4592 22.5095
            L59.2497 13.9123
            L51.9414 8.5972
            H60.9771
            L63.7675 0
            Z"
          fill="#12100D"
          />
          <path d="M115.711 0
            L118.501 8.5972
            H127.537
            L120.228 13.9123
            L123.019 22.5095
            L115.711 17.1944
            L108.389 22.5095
            L111.193 13.9123
            L103.871 8.5972
            H112.92
            L115.711 0
            Z"
          fill="#12100D"
          />
          <path d="M319.445 1.26538
            C325.764 1.26538 330.71 3.29376 334.327 7.35055
            C337.929 11.4073 339.746 17.035 339.746 24.2487
            C339.746 31.4625 337.944 37.4562 334.327 41.6807
            C330.725 45.9052 325.764 48.0099 319.445 48.0099
            H318.774
            V68.7347
            H305.25
            V1.28062
            H319.461
            L319.445 1.26538
            Z
            M319.445 35.6413
            C321.567 35.6413 323.231 34.6652 324.421 32.6978
            C325.612 30.7304 326.207 28.0462 326.207 24.63
            C326.207 21.2138 325.612 18.5296 324.421 16.5622
            C323.231 14.5948 321.567 13.6187 319.445 13.6187
            H318.774
            V35.626
            H319.445
            V35.6413
            Z
            M376.545 68.7347
            H348.522
            V1.25012
            H362.045
            V56.4648
            H376.53
            V68.7347
            H376.545
            Z
            M423.694 68.7347
            H409.01
            L407.179 54.7356
            H398.677
            L396.846 68.7347
            H382.925
            L394.327 1.25012
            H411.712
            L423.694 68.7347
            Z
            M405.82 43.5566
            C404.141 29.0681 403.18 19.3531 402.92 14.3965
            C402.6 20.5732 401.638 30.2881 400.02 43.5566
            H405.82
            Z
            M448.145 68.7347
            H434.622
            V13.512
            H426.212
            V1.25012
            H456.556
            V13.512
            H448.145
            V68.7347
            Z
            M479.634 68.7347
            H466.11
            V1.25012
            H479.634
            V68.7347
            Z
            M526.889 1.26538
            V68.7347
            H514.709
            L501.857 30.1356
            C502.635 34.955 503.139 40.1251 503.399 45.6307
            C503.658 51.1363 503.78 58.1047 503.78 68.7347
            H491.219
            V1.26538
            H503.399
            L516.25 41.3299
            C515.472 36.5716 514.968 31.3862 514.709 25.7891
            C514.449 20.1919 514.327 12.0174 514.327 1.26538
            H526.889
            Z
            M542.152 64.0069
            C539.054 60.8499 537.512 56.5034 537.512 50.9672
            V1.26538
            H550.944
            V50.9672
            C550.944 52.6449 551.295 53.9565 552.012 54.9325
            C552.714 55.8933 553.691 56.3814 554.912 56.3814
            C556.133 56.3814 557.08 55.8933 557.766 54.9325
            C558.438 53.9717 558.774 52.6449 558.774 50.9672
            V1.26538
            H572.206
            V50.9672
            C572.206 56.5034 570.679 60.8499 567.611 64.0069
            C564.559 67.1639 560.142 68.7347 554.739 68.7347
            C549.336 68.7347 545.251 67.1639 542.152 64.0069
            Z
            M611.997 1.26538
            H624.269
            V68.7347
            H611.707
            C611.707 53.0871 611.799 43.7091 611.997 38.4017
            C612.195 33.0943 612.745 28.1835 613.645 23.6844
            L603.495 48.8792
            L593.254 23.1964
            C594.215 28.3513 594.795 33.3994 594.994 38.356
            C595.192 43.3126 595.284 52.7211 595.284 68.75
            H582.814
            V1.28062
            H595.085
            L603.495 22.9066
            L611.997 1.28062
            V1.26538
            Z"
          fill="#12100D"
          />
        </symbol>

        <symbol fill="none"
          id="time-sort"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_642_880)">
            <path clipRule="evenodd"
              d="M12 4
            C7.58172 4 4 7.58172 4 12
            C4 16.4183 7.58172 20 12 20
            C16.4183 20 20 16.4183 20 12
            C20 7.58172 16.4183 4 12 4
            Z
            M2 12
            C2 6.47715 6.47715 2 12 2
            C17.5228 2 22 6.47715 22 12
            C22 17.5228 17.5228 22 12 22
            C6.47715 22 2 17.5228 2 12
            Z"
              fill="#DD0000"
              fillRule="evenodd"
            />
            <path clipRule="evenodd"
              d="M12 5.25
            C12.5523 5.25 13 5.69772 13 6.25
            V11
            H15.79
            C16.3423 11 16.79 11.4477 16.79 12
            C16.79 12.5523 16.3423 13 15.79 13
            H11
            V6.25
            C11 5.69772 11.4477 5.25 12 5.25
            Z"
              fill="#DD0000"
              fillRule="evenodd"
            />
          </g>
          <defs>
            <clipPath id="clip0_642_880">
              <rect fill="white"
                height="24"
                width="24"
              />
            </clipPath>
          </defs>
        </symbol>

        <symbol id="showtime-list"
          viewBox="0 0 18 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M15 0
            H3
            C2.20435 0 1.44129 0.31607 0.87868 0.87868
            C0.31607 1.44129 0 2.20435 0 3
            V17
            C0 17.7956 0.31607 18.5587 0.87868 19.1213
            C1.44129 19.6839 2.20435 20 3 20
            H15
            C15.7956 20 16.5587 19.6839 17.1213 19.1213
            C17.6839 18.5587 18 17.7956 18 17
            V3
            C18 2.20435 17.6839 1.44129 17.1213 0.87868
            C16.5587 0.31607 15.7956 0 15 0
            Z
            M6.29 15
            C6.29 15.2652 6.18464 15.5196 5.99711 15.7071
            C5.80957 15.8946 5.55522 16 5.29 16
            H4.58
            C4.31478 16 4.06043 15.8946 3.87289 15.7071
            C3.68536 15.5196 3.58 15.2652 3.58 15
            V12.6
            C3.58 12.3348 3.68536 12.0804 3.87289 11.8929
            C4.06043 11.7054 4.31478 11.6 4.58 11.6
            H5.29
            C5.55522 11.6 5.80957 11.7054 5.99711 11.8929
            C6.18464 12.0804 6.29 12.3348 6.29 12.6
            V15
            Z
            M6.29 7.34
            C6.29 7.60522 6.18464 7.85957 5.99711 8.04711
            C5.80957 8.23464 5.55522 8.34 5.29 8.34
            H4.58
            C4.31478 8.34 4.06043 8.23464 3.87289 8.04711
            C3.68536 7.85957 3.58 7.60522 3.58 7.34
            V4.97
            C3.58 4.70478 3.68536 4.45043 3.87289 4.26289
            C4.06043 4.07536 4.31478 3.97 4.58 3.97
            H5.29
            C5.55522 3.97 5.80957 4.07536 5.99711 4.26289
            C6.18464 4.45043 6.29 4.70478 6.29 4.97
            V7.34
            Z
            M13.67 16
            H8.38
            C8.18374 16 7.99552 15.922 7.85674 15.7833
            C7.71796 15.6445 7.64 15.4563 7.64 15.26
            C7.64 15.0637 7.71796 14.8755 7.85674 14.7367
            C7.99552 14.598 8.18374 14.52 8.38 14.52
            H13.67
            C13.8663 14.52 14.0545 14.598 14.1933 14.7367
            C14.332 14.8755 14.41 15.0637 14.41 15.26
            C14.41 15.4563 14.332 15.6445 14.1933 15.7833
            C14.0545 15.922 13.8663 16 13.67 16
            Z
            M13.67 13.07
            H8.38
            C8.27628 13.0821 8.17117 13.0721 8.07158 13.0407
            C7.97199 13.0093 7.88017 12.9572 7.80216 12.8878
            C7.72415 12.8184 7.66172 12.7332 7.61897 12.6379
            C7.57622 12.5427 7.55412 12.4394 7.55412 12.335
            C7.55412 12.2306 7.57622 12.1273 7.61897 12.0321
            C7.66172 11.9368 7.72415 11.8516 7.80216 11.7822
            C7.88017 11.7128 7.97199 11.6607 8.07158 11.6293
            C8.17117 11.5979 8.27628 11.5879 8.38 11.6
            H13.67
            C13.7737 11.5879 13.8788 11.5979 13.9784 11.6293
            C14.078 11.6607 14.1698 11.7128 14.2478 11.7822
            C14.3258 11.8516 14.3883 11.9368 14.431 12.0321
            C14.4738 12.1273 14.4959 12.2306 14.4959 12.335
            C14.4959 12.4394 14.4738 12.5427 14.431 12.6379
            C14.3883 12.7332 14.3258 12.8184 14.2478 12.8878
            C14.1698 12.9572 14.078 13.0093 13.9784 13.0407
            C13.8788 13.0721 13.7737 13.0821 13.67 13.07
            Z
            M13.67 8.34
            H8.38
            C8.27628 8.35212 8.17117 8.34215 8.07158 8.31074
            C7.97199 8.27934 7.88017 8.22721 7.80216 8.15779
            C7.72415 8.08836 7.66172 8.00322 7.61897 7.90794
            C7.57622 7.81267 7.55412 7.70943 7.55412 7.605
            C7.55412 7.50057 7.57622 7.39733 7.61897 7.30206
            C7.66172 7.20678 7.72415 7.12163 7.80216 7.05221
            C7.88017 6.98279 7.97199 6.93066 8.07158 6.89926
            C8.17117 6.86785 8.27628 6.85788 8.38 6.87
            H13.67
            C13.7737 6.85788 13.8788 6.86785 13.9784 6.89926
            C14.078 6.93066 14.1698 6.98279 14.2478 7.05221
            C14.3258 7.12163 14.3883 7.20678 14.431 7.30206
            C14.4738 7.39733 14.4959 7.50057 14.4959 7.605
            C14.4959 7.70943 14.4738 7.81267 14.431 7.90794
            C14.3883 8.00322 14.3258 8.08836 14.2478 8.15779
            C14.1698 8.22721 14.078 8.27934 13.9784 8.31074
            C13.8788 8.34215 13.7737 8.35212 13.67 8.34
            Z
            M13.67 5.41
            H8.38
            C8.27628 5.42212 8.17117 5.41215 8.07158 5.38074
            C7.97199 5.34934 7.88017 5.29721 7.80216 5.22779
            C7.72415 5.15837 7.66172 5.07322 7.61897 4.97794
            C7.57622 4.88267 7.55412 4.77943 7.55412 4.675
            C7.55412 4.57057 7.57622 4.46733 7.61897 4.37206
            C7.66172 4.27678 7.72415 4.19164 7.80216 4.12221
            C7.88017 4.05279 7.97199 4.00066 8.07158 3.96926
            C8.17117 3.93785 8.27628 3.92788 8.38 3.94
            H13.67
            C13.7737 3.92788 13.8788 3.93785 13.9784 3.96926
            C14.078 4.00066 14.1698 4.05279 14.2478 4.12221
            C14.3258 4.19164 14.3883 4.27678 14.431 4.37206
            C14.4738 4.46733 14.4959 4.57057 14.4959 4.675
            C14.4959 4.77943 14.4738 4.88267 14.431 4.97794
            C14.3883 5.07322 14.3258 5.15837 14.2478 5.22779
            C14.1698 5.29721 14.078 5.34934 13.9784 5.38074
            C13.8788 5.41215 13.7737 5.42212 13.67 5.41
            Z"
          />
        </symbol>

        <symbol fill="none"
          id="play"
          viewBox="0 0 15 17"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M14.292 8.16921L7.146 12.3534L0 16.3324V0L7.146 3.97801L14.292 8.16921Z"
            fill="white"
          />
        </symbol>

        <symbol fill="none"
          id="guest_services"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <g clipPath="url(#clip0_642_893)">
            <path clipRule="evenodd"
              d="M15.3994 11.6667
            C16.3839 10.7535 17 9.44871 17 8
            C17 5.23858 14.7614 3 12 3
            C9.23858 3 7 5.23858 7 8
            C7 9.44871 7.61612 10.7535 8.60063 11.6667
            C7.50165 12.115 6.49159 12.7805 5.63604 13.636
            C3.94821 15.3239 3 17.6131 3 20
            C3 20.5523 3.44772 21 4 21
            C4.55228 21 5 20.5523 5 20
            C5 18.1435 5.7375 16.363 7.05025 15.0503
            C8.36301 13.7375 10.1435 13 12 13
            C13.8565 13 15.637 13.7375 16.9497 15.0503
            C18.2625 16.363 19 18.1435 19 20
            C19 20.5523 19.4477 21 20 21
            C20.5523 21 21 20.5523 21 20
            C21 17.6131 20.0518 15.3239 18.364 13.636
            C17.5084 12.7805 16.4984 12.115 15.3994 11.6667
            Z
            M9 8
            C9 6.34315 10.3431 5 12 5
            C13.6569 5 15 6.34315 15 8
            C15 9.65685 13.6569 11 12 11
            C10.3431 11 9 9.65685 9 8
            Z"
              fill="currentColor"
              fillRule="evenodd"
            />
            <path clipRule="evenodd"
              d="M12.33 17
            C12.33 16.4477 12.7777 16 13.33 16
            H15.75
            C16.3023 16 16.75 16.4477 16.75 17
            C16.75 17.5523 16.3023 18 15.75 18
            H13.33
            C12.7777 18 12.33 17.5523 12.33 17
            Z"
              fill="currentColor"
              fillRule="evenodd"
            />
          </g>
          <defs>
            <clipPath id="clip0_642_893">
              <rect fill="white"
                height="24"
                width="24"
              />
            </clipPath>
          </defs>

        </symbol>

        <symbol fill="none"
          id="private_events"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <circle cx="5"
            cy="5"
            r="2"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <circle cx="19"
            cy="5"
            r="2"
            stroke="currentColor"
            strokeWidth="1.5"
          />
          <path d="M6 6.5C6 6.5 7.5 10 12 10C16.5 10 18 6.5 18 6.5"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path d="M5 7V19"
            stroke="currentColor"
            strokeWidth="2.5"
          />
          <ellipse cx="5"
            cy="19.5"
            fill="currentColor"
            rx="3"
            ry="1.5"
          />
          <path d="M19 7V19"
            stroke="currentColor"
            strokeWidth="2.5"
          />
          <ellipse cx="19"
            cy="19.5"
            fill="currentColor"
            rx="3"
            ry="1.5"
          />

        </symbol>

        <symbol fill="none"
          id="question"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M12 21
            C16.9706 21 21 16.9706 21 12
            C21 7.02944 16.9706 3 12 3
            C7.02944 3 3 7.02944 3 12
            C3 16.9706 7.02944 21 12 21
            Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          />
          <circle cx="12"
            cy="17"
            fill="currentColor"
            r="1"
          />
          <path d="M12 14
            C12 12.6957 12.1829 12.4521 13.3044 11.8913
            C14.6087 11.2391 14.6087 10 14.6087 9.6087
            C14.6087 7 12.5 7 12 7
            C10 7 9.39131 8.5 9.39131 9.6087
            V10"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          />

        </symbol>

        <symbol fill="none"
          id="ic_questions"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path clipRule="evenodd"
            d="M12 4
            C7.58172 4 4 7.58172 4 12
            C4 16.4183 7.58172 20 12 20
            C16.4183 20 20 16.4183 20 12
            C20 7.58172 16.4183 4 12 4
            Z
            M2 12
            C2 6.47715 6.47715 2 12 2
            C17.5228 2 22 6.47715 22 12
            C22 17.5228 17.5228 22 12 22
            C6.47715 22 2 17.5228 2 12
            Z"
            fill="#DD0000"
            fillRule="evenodd"
          />
          <circle cx="12"
            cy="17"
            fill="#DD0000"
            r="1"
          />
          <path clipRule="evenodd"
            d="M13.0079 8.20122
            C12.6645 8.01134 12.248 8.00002 12 8.00002
            C11.2826 8.00002 10.9308 8.25248 10.733 8.50514
            C10.5034 8.79828 10.3913 9.21393 10.3913 9.60872
            V10
            C10.3913 10.5523 9.94358 11 9.3913 11
            C8.83901 11 8.3913 10.5523 8.3913 10
            V9.60872
            C8.3913 8.89482 8.58351 8.00611 9.15831 7.27208
            C9.76481 6.49757 10.7173 6.00002 12 6.00002
            C12.0056 6.00002 12.0115 6.00002 12.0176 6.00001
            C12.2913 5.99976 13.1583 5.99894 13.9758 6.451
            C14.4131 6.69285 14.8365 7.0633 15.1438 7.61184
            C15.4488 8.15621 15.6087 8.82095 15.6087 9.60872
            C15.6087 9.61252 15.6087 9.61644 15.6087 9.62048
            C15.6089 10.0529 15.6096 11.8567 13.7516 12.7858
            C13.1633 13.0799 13.0935 13.1748 13.0768 13.2012
            C13.0633 13.2226 13 13.3324 13 14
            C13 14.5523 12.5523 15 12 15
            C11.4477 15 11 14.5523 11 14
            C11 13.3633 11.0281 12.6991 11.3864 12.1324
            C11.7415 11.5707 12.3239 11.2635 12.8571 10.9969
            C13.5904 10.6303 13.6087 9.9809 13.6087 9.60872
            C13.6087 9.09215 13.505 8.77862 13.399 8.5893
            C13.2952 8.40414 13.1602 8.28546 13.0079 8.20122
            Z"
            fill="#DD0000"
            fillRule="evenodd"
          />

        </symbol>

        <symbol fill="none"
          id="chevron-down"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M10 15L3 7.766L4.387 6.333L10 12.134L15.613 6.334L17 7.766L10 15Z"
            fill="currentColor"
          />

        </symbol>
        <symbol fill="none"
          id="chevron-up"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M10 5L17 12.234L15.613 13.667L10 7.866L4.387 13.666L3 12.234L10 5Z"
            fill="currentColor"
          />

        </symbol>

        <symbol fill="none"
          id="chevron-right"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M15 10L7.766 17L6.333 15.613L12.134 10L6.334 4.387L7.766 3L15 10Z"
            fill="currentColor"
          />

        </symbol>

        <symbol fill="none"
          id="chevron-left"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M5 10L12.234 3L13.667 4.387L7.866 10L13.666 15.613L12.234 17L5 10Z"
            fill="currentColor"
          />

        </symbol>

        <symbol fill="none"
          id="checkbox"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M4 11.489L7.734 15.174"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="3"
          />
          <path d="M16.947 6L7.81799 15.068"
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="3"
          />

        </symbol>

        <symbol fill="none"
          id="eye"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path clipRule="evenodd"
            d="M16 12
            C16 14.2091 14.2091 16 12 16
            C9.79086 16 8 14.2091 8 12
            C8 9.79086 9.79086 8 12 8
            C14.2091 8 16 9.79086 16 12
            Z
            M13.3333 12
            C13.3333 12.7364 12.7364 13.3333 12 13.3333
            C11.2636 13.3333 10.6667 12.7364 10.6667 12
            C10.6667 11.2636 11.2636 10.6667 12 10.6667
            C12.7364 10.6667 13.3333 11.2636 13.3333 12
            Z"
            fill="currentColor"
            fillRule="evenodd"
          />
          <path clipRule="evenodd"
            d="M1.1783 12.5703
            C1.15532 12.5371 1.13443 12.5027 1.11571 12.4672
            C1.0476 12.3386 1.01023 12.2005 1.00174 12.0622
            C0.992997 11.9238 1.01297 11.7821 1.06464 11.646
            C1.07904 11.6079 1.09579 11.5705 1.11484 11.5343
            C2.00854 9.75773 5.43018 4.5 12 4.5
            C18.2854 4.5 21.5556 9.49641 22.6767 11.2092
            C22.7298 11.2904 22.7781 11.3642 22.8217 11.4297
            C22.8446 11.4628 22.8654 11.4972 22.8841 11.5327
            C22.9523 11.6613 22.9897 11.7994 22.9982 11.9378
            C23.007 12.0762 22.987 12.2178 22.9354 12.3538
            C22.921 12.392 22.9042 12.4294 22.8851 12.4657
            C21.9914 14.2423 18.5697 19.5 12 19.5
            C5.71459 19.5 2.44435 14.5036 1.32328 12.7908
            C1.27017 12.7096 1.22185 12.6358 1.1783 12.5703
            Z
            M12 6.5
            C7.08916 6.5 4.23746 10.1061 3.16528 11.9482
            C4.40642 13.8073 7.10325 17.5 12 17.5
            C16.9108 17.5 19.7625 13.8939 20.8347 12.0518
            C19.5935 10.1927 16.8967 6.5 12 6.5
            Z"
            fill="currentColor"
            fillRule="evenodd"
          />

        </symbol>

        <symbol fill="none"
          id="eye-off"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path clipRule="evenodd"
            d="M4.43315 7.34733
            C2.64237 8.88461 1.56221 10.6451 1.11497 11.5341
            C1.09566 11.5709 1.07872 11.6087 1.06419 11.6474
            C1.01281 11.7832 0.993019 11.9247 1.00185 12.0628
            C1.01039 12.2006 1.04755 12.338 1.11516 12.466
            C1.13406 12.502 1.15519 12.5369 1.17847 12.5704
            C1.22191 12.6358 1.27005 12.7093 1.32299 12.7902
            C2.44406 14.503 5.71465 19.5 12 19.5
            C13.4546 19.5 14.7548 19.2423 15.9075 18.8217
            L14.3051 17.2193
            C13.5942 17.3979 12.8262 17.5 12 17.5
            C7.10332 17.5 4.40649 13.8073 3.16534 11.9482
            C3.66507 11.0897 4.55135 9.84792 5.85249 8.76667
            L4.43315 7.34733
            Z
            M8.11793 11.0321
            C8.04091 11.342 8.00003 11.6662 8.00003 12
            C8.00003 14.2091 9.79089 16 12 16
            C12.3338 16 12.658 15.9591 12.9679 15.8821
            L8.11793 11.0321
            Z
            M13.9777 15.4777
            L15.3784 16.8784
            L16.9028 18.4028
            L19.4706 20.9706
            C19.8123 21.3123 20.3398 21.355 20.7279 21.0987
            C20.7834 21.0621 20.836 21.0194 20.8848 20.9706
            C21.2265 20.6288 21.2692 20.1014 21.0129 19.7132
            C20.9763 19.6578 20.9336 19.6052 20.8848 19.5563
            L18.6787 17.3502
            L17.2391 15.9107
            L15.414 14.0855
            L9.9145 8.58604
            L8.49864 7.17018
            L6.98172 5.65326
            L4.62135 3.29289
            C4.23083 2.90237 3.59766 2.90237 3.20714 3.29289
            C2.81661 3.68342 2.81661 4.31658 3.20714 4.70711
            M7.96751 5.22483
            L9.55867 6.81599
            C10.3075 6.61561 11.1207 6.5 12 6.5
            C16.8967 6.5 19.5936 10.1927 20.8347 12.0518
            C20.323 12.9309 19.406 14.2118 18.0534 15.3107
            L19.4742 16.7315
            C21.3205 15.176 22.4302 13.37 22.8851 12.4658
            C22.9703 12.3036 23.0094 12.1205 22.9982 11.9379
            C22.9898 11.7999 22.9526 11.6622 22.8849 11.534
            C22.866 11.4981 22.8449 11.4632 22.8216 11.4296
            C22.7781 11.3641 22.7299 11.2904 22.6768 11.2094
            C21.5557 9.49661 18.2854 4.5 12 4.5
            C10.4926 4.5 9.15094 4.7768 7.96751 5.22483
            Z
            M15.8459 13.1033
            C15.9463 12.7528 16 12.3827 16 12
            C16 9.79086 14.2091 8 12 8
            C11.6173 8 11.2472 8.05374 10.8967 8.15409
            L15.8459 13.1033
            Z"
            fill="currentColor"
            fillRule="evenodd"
          />

        </symbol>

        <symbol fill="none"
          id="more-horizontal"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <g clipPath="url(#clip0_642_1625)">
            <path d="M4.59998 10
            C5.70455 10 6.59998 10.8954 6.59998 12
            C6.59998 13.1046 5.70455 14 4.59998 14
            C3.49541 14 2.59998 13.1046 2.59998 12
            C2.59998 10.8954 3.49541 10 4.59998 10
            Z
            M12.0004 10
            C13.1048 10.0002 14.0004 10.8956 14.0004 12
            C14.0004 13.1044 13.1048 13.9998 12.0004 14
            C10.8958 14 10.0004 13.1046 10.0004 12
            C10.0004 10.8954 10.8958 10 12.0004 10
            Z
            M19.3998 10
            C20.5044 10 21.3998 10.8954 21.3998 12
            C21.3998 13.1046 20.5044 14 19.3998 14
            C18.2953 13.9999 17.3998 13.1045 17.3998 12
            C17.3998 10.8955 18.2953 10.0001 19.3998 10
            Z"
            fill="currentColor"
            stroke="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_642_1625">
              <rect fill="white"
                height="24"
                width="24"
              />
            </clipPath>
          </defs>

        </symbol>

        <symbol fill="none"
          id="wheelchair"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >

          <circle cx="8"
            cy="3"
            fill="currentColor"
            r="2"
          />
          <path d="M8.42193 6.00295
            C8.97238 5.96087 9.45281 6.37337 9.49518 6.92385
            L9.65436 9.00002
            H13.9991
            C14.5513 9.0001 14.9991 9.44779 14.9991 10
            C14.999 10.5522 14.5513 10.9999 13.9991 11
            H9.80865
            L9.92389 12.5
            H15.4981
            C16.498 12.5 16.777 12.8523 17.1378 13.6758
            C17.4098 14.2969 18.5746 17.373 19.1319 18.8487
            C19.8316 18.6855 20.7003 18.5 20.9981 18.5
            C21.2497 18.5 21.3745 18.7533 21.4366 19.0049
            C21.512 19.3105 21.3498 19.6115 21.0899 19.7891
            C20.4803 20.2056 19.3259 20.9295 18.5987 20.9932
            C18.5709 20.996 18.5433 20.9976 18.5157 20.9981
            C18.5105 20.9982 18.5052 21 18.5001 21
            C18.4981 21 18.4961 20.9991 18.4942 20.999
            C18.0941 20.9973 17.7169 20.7553 17.5645 20.3594
            L15.3116 14.5
            H8.99811
            C8.19816 14.5 7.98653 13.7025 7.98053 13.3037
            C7.95569 12.3443 7.50554 7.12939 7.50103 7.07717
            C7.45869 6.52655 7.87131 6.04534 8.42193 6.00295
            Z"
          fill="currentColor"
          />
          <path d="M6.18066 11.7739
            C5.44437 12.6447 5 13.7708 5 15.0005
            C5.00026 17.7617 7.23874 20.0005 10 20.0005
            C12.313 20.0005 14.258 18.4292 14.8291 16.2964
            L15.9395 18.7026
            C14.7028 20.6821 12.506 22.0005 10 22.0005
            C6.13417 22.0005 3.00026 18.8663 3 15.0005
            C3 12.656 4.15341 10.5814 5.92285 9.31104
            L6.18066 11.7739
            Z"
          fill="currentColor"
          />

        </symbol>

        <symbol fill="none"
          id="wheelchair-companion"
          viewBox="0 0 211 180"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M154.97 33.1311
            C160.566 33.0407 166.163 33.029 171.759 33.0954
            C185.33 33.2199 185.059 32.8588 189.434 45.9012
            C191.023 50.5992 192.581 55.3078 194.105 60.0268
            L199.229 75.8389
            C200.837 80.8042 202.451 85.3757 203.347 90.6304
            C204.056 94.7793 202.435 97.794 197.764 97.8989
            C195.95 97.9395 194.463 96.688 193.63 95.0613
            C187.745 83.5615 184.788 70.8121 179.657 58.9558
            C179.719 61.5236 179.249 64.6715 179.188 67.2817
            C179.084 71.5859 178.896 76.5638 179.181 80.8383
            C179.661 88.0671 181.074 95.3775 182.067 102.53
            L189.302 152.562
            C189.749 155.757 191.47 167.377 191.292 169.956
            C191.255 170.537 191.078 171.1 190.773 171.597
            C189.246 174.153 184.415 174.116 182.074 172.871
            C179.859 171.692 179.351 167.097 178.857 164.685
            C178.193 161.328 177.491 157.979 176.755 154.638
            L167.121 111.4
            C166.547 108.396 165.427 103.457 164.388 100.775
            C163.902 107.123 162.726 112.337 161.631 118.541
            L155.81 150.527
            C155.277 153.536 154.72 157.157 154.001 160.054
            C152.591 165.734 153.041 175.318 144.461 173.611
            C142.432 173.207 141.577 172.448 140.497 170.856
            C140.342 167.698 140.952 164.208 141.359 161.049
            C141.952 156.292 142.594 151.541 143.284 146.797
            L149.076 107.167
            C151.263 91.9851 154.213 77.4694 152.202 62.0963
            C152.073 61.11 151.977 60.1044 151.86 59.114
            C148.031 69.5303 143.961 79.8058 140.477 90.4024
            C139.054 94.7324 134.935 100.837 129.847 96.3677
            C126.047 93.0291 129.714 84.7164 131.077 80.5011
            L135.35 67.3077
            C137.286 61.3055 139.257 55.3143 141.26 49.3343
            C142.377 45.9761 143.449 42.5695 144.685 39.256
            C146.925 33.2489 149.35 33.2235 154.97 33.1311
            Z"
          fill="currentColor"
          />
          <path d="M38.8681 60.6662
            C38.9642 60.6551 39.0607 60.6452 39.1573 60.637
            C42.7096 60.3104 46.808 61.2366 47.841 64.9549
            C49.1675 69.7286 49.5023 75.9632 49.9233 80.8717
            C58.5094 80.591 67.3717 81.0021 75.9701 80.8641
            C80.9751 80.7838 83.7387 84.3328 82.8078 89.112
            C82.339 91.5189 80.3511 92.6712 78.0415 92.9227
            C74.0252 93.3469 69.9821 93.0848 65.9511 93.1618
            C61.2626 93.0788 56.3399 93.3546 51.6776 93.082
            C51.636 95.6231 51.64 98.1649 51.6896 100.706
            C53.5873 100.681 56.9484 101.109 58.9311 101.304
            L70.7437 102.413
            C74.0825 102.735 77.4255 103.012 80.7719 103.244
            C91.0131 103.852 94.5821 102.424 99.1727 112.986
            C103.917 123.901 108.603 135.077 113.475 145.929
            C114.802 145.595 115.747 145.424 117.103 145.217
            C119.315 144.762 121.767 144.426 124.02 144.307
            C125.64 144.221 127.241 144.49 128.47 145.629
            C129.279 146.379 129.948 147.519 129.976 148.643
            C129.991 149.251 129.85 149.961 129.411 150.405
            C127.49 152.345 113.325 157.136 109.799 157.864
            C108.826 158.065 107.859 158.059 106.871 158.048
            C103.698 155.559 102.34 151.712 100.706 148.123
            C98.6694 143.584 96.6848 139.023 94.7532 134.439
            C93.0597 130.577 91.4047 126.698 89.7886 122.803
            C89.032 121.022 87.9685 118.91 87.3649 117.118
            C80.5221 117.359 73.1584 117.237 66.2849 117.226
            C59.1253 117.216 47.4404 118.015 41.2601 114.559
            C38.9903 113.272 37.329 111.13 36.6455 108.612
            C36.0199 106.286 35.9308 102.607 35.7691 100.141
            C35.5421 96.7874 35.2913 93.4358 35.0166 90.0861
            C34.4143 82.6233 33.6252 75.1957 33.0569 67.7313
            C32.731 63.4523 34.907 61.6635 38.8681 60.6662
            Z"
          fill="currentColor"
          />
          <path d="M26.2057 89.8348
            C26.5049 90.257 27.9873 103.869 27.9456 105.138
            C23.8147 110.173 20.9497 115.572 19.5995 121.987
            C17.8229 130.832 19.5963 140.022 24.5368 147.571
            C29.6118 155.302 37.5577 160.693 46.6169 162.551
            C55.3618 164.374 64.4726 162.618 71.9132 157.674
            C78.9007 153.079 84.1986 145.924 86.3618 137.647
            C86.4493 137.312 86.3227 137.554 86.6282 137.219
            C88.0018 138.066 92.41 150.141 93.9958 152.783
            C92.9861 154.166 91.9938 155.561 91.0191 156.97
            C90.6647 157.515 90.0876 158.169 89.6596 158.691
            C69.8875 182.839 31.9626 180.617 14.5785 154.894
            C7.47506 144.247 4.92534 131.202 7.49751 118.664
            C9.68805 107.456 16.7033 96.2422 26.2057 89.8348
            Z"
          fill="currentColor"
          />
          <path d="M37.9585 30.9926
            C45.4678 29.9131 52.4335 35.1169 53.5281 42.6238
            C54.6229 50.1309 49.4335 57.1071 41.9285 58.2172
            C34.4021 59.3304 27.4014 54.1227 26.3035 46.594
            C25.2057 39.0653 30.4276 32.0752 37.9585 30.9926
            Z"
          fill="currentColor"
          />
          <path d="M162.279 4.62329
            C169.773 3.25057 176.954 8.2362 178.288 15.7376
            C179.62 23.2392 174.596 30.3935 167.088 31.6865
            C159.636 32.9701 152.546 27.9921 151.224 20.5467
            C149.9 13.1013 154.841 5.98576 162.279 4.62329
            Z"
          fill="currentColor"
          />
        </symbol>

        <symbol fill="none"
          id="seatmap-screen"
          viewBox="0 0 335 22"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M331.752 21.1898
            C331.419 21.1898 331.082 21.1358 330.749 21.0278
            C304.396 12.2911 240.314 6.64386 167.501 6.64386
            C94.6884 6.64386 30.6071 12.2911 4.24953 21.0278
            C2.54459 21.5925 0.713813 20.6375 0.157678 18.8935
            C-0.394397 17.1495 0.53926 15.2767 2.2442 14.7078
            C29.1944 5.77185 94.0632 0 167.501 0
            C240.94 0 305.804 5.77185 332.755 14.7078
            C334.459 15.2726 335.397 17.1453 334.841 18.8935
            C334.399 20.297 333.124 21.1898 331.752 21.1898
            Z"
          fill="currentColor"
          fillOpacity="0.12"
          />

        </symbol>

        <symbol fill="none"
          id="seatmap-zoom-in"
          viewBox="0 0 30 30"
          xmlns="http://www.w3.org/2000/svg"
        >

          <circle cx="15"
            cy="15"
            r="14"
            stroke="#dd0000"
            strokeWidth="2"
          />
          <path d="M8.32936 12.5024L8.03379 8.06893L12.4673 8.36449"
            stroke="#dd0000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path d="M13.3541 13.3891L8.47729 8.5123"
            stroke="#dd0000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path d="M21.6003 17.4975L21.8959 21.931L17.4624 21.6354"
            stroke="#dd0000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path d="M16.5757 16.6109L21.4525 21.4877"
            stroke="#dd0000"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />

        </symbol>

        <symbol fill="none"
          id="seatmap-zoom-out"
          viewBox="0 0 30 30"
          xmlns="http://www.w3.org/2000/svg"
        >

          <circle cx="15"
            cy="15"
            fill="#dd0000"
            r="14"
            stroke="#dd0000"
            strokeWidth="2"
          />
          <path d="M13.0583 8.9558L13.3539 13.3893L8.92044 13.0937"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path d="M8.03359 8.06908L12.9104 12.9459"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path d="M16.8713 21.0443L16.5758 16.6109L21.0092 16.9064"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />
          <path d="M21.8959 21.931L17.019 17.0542"
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
          />

        </symbol>

        <symbol fill="none"
          id="check_green"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >

          <path d="M4 11.489L7.734 15.174"
            stroke="#28AA00"
            strokeLinecap="round"
            strokeWidth="3"
          />
          <path d="M16.947 6L7.81799 15.068"
            stroke="#28AA00"
            strokeLinecap="round"
            strokeWidth="3"
          />

        </symbol>

      </defs>
    </svg>
  );
};
